import { Baseline, Measure, VisionStep, WidgetConfigurationItemObj, WidgetConfigurationObj } from "@wizeoo/akm-message-lib";
import { CellPosition } from "ag-grid-community";
import { FeiVO } from "../../vo/workingdata/fei.vo";
import { Model } from "../../model/model";
import { IFreedataWidget, IWidget, IWidgetFilter } from "./i-widget";
import { FreeDataVO } from "../../vo/core/freedata.vo";
import { GridsterWidget } from "../../vo/workingzone/gridster-widget";
import { FreedataArgsVO } from "../../vo/core/freedataargs.vo";
import { FreedataValueVO } from "../../vo/core/freedatavalue.vo";
import { BaselineEngine, COMPUTE_MODE, ComputeResult, EM_ACTION, FIELD_KIND, FeiKeyDef, FormulaCoreEngine, KEY_KIND, MeasMode, MeasureCoreEngine, MeasureVO, WidgetLine, WizConstants } from "@wizeoo/akm-compute-lib";
import { UserVO } from "../../vo/user/user.vo";
import { UserApplicationVO} from "../../vo/user/user-app.vo";
import { WizAgGridUtils, WizEventManager, WizRoot, WizTranslationManager } from "@wizeoo/akm-component-lib";
import { ALK_EVENT_TYPE, COMPARATOR, WIDGET_GLOBAL_KIND } from "../../model/enums";
import { AlkEvent } from "../../framework/events/alk.event";
import { WIDGET_KIND } from "../../model/enums";
import { VisionKeyObj } from "../../vo/vision/tools/visionkey.obj";
import { WizColDef } from "../workingdata/fei.engine";
import { UpdateEntry } from "../../command/core/sync/sync.service";
import { cloneDeep } from 'lodash-es';
import { PivotField } from "../baselines/pivot-field.obj";
import { StyleEngine } from "../../manager/workingdata/style.engine";
import { StyleLineVO } from "../../vo/workingdata/styleline.vo";
import { StyleVO } from "../../vo/workingdata/style.vo";
import { PivotCellEditor } from "../../components/widgets/pivot/renderers/cells/pivot-cell.editor";
import { ViewData } from "../../model/view.data";
import { FormatVO } from "../../vo/workingdata/format.vo";
import { FreedataSeqCmd } from "../../command/core/freedatas/freedataseq.cmd";

// import { FreedataFormWidget } from "../../components/widgets/freedataform/freedata-form.widget";

/** conf par défaut d'un widget */
export function getDefaultWidgetConfigurationObj(): WidgetConfigurationObj {
  return {
    c: null, // colonnes
    cp: null, // chart's params
    ct: null, // type de chart
    d: null, // datas
    eda: true, // édition autorisée
    hme: false, // massEdit depuis les headers
    f: null, // filters
    fdk: null, // Freedata code#level du FD cible
    ff: null, // Les champs à afficher dans le widget advanced form
    g: null, // groupes de colonnes custom
    gps: null, // @Specific GRID et PIVOT mémorisation de l'état des groupes (expand / closed)
    rowGps: null, // @Specific PIVOT mémorisation de l'état des groupes de lignes (expand / closed)
    i: null, // clés de contrôle d'intégrité
    icre: null, // contrôle d'intégrité sur create
    idel: null, // contrôle d'intégrité sur delete
    iupd: null, // contrôle d'intégrité sur update
    k: null, // type de widget (widget_kind.xxx)
    mefe: null, // mode empty for empty sur le master (pas de données si pas de sélection) 
    muid: null, // UID du master
    nxstep: null, // affichage des clés du nextStep dans un formulaire
    pm: false, // pas en mode pivot
    pmd: false, // affichage gigogne en mode pivot
    r: null, // rows
    sa: false, // conf par user disabled
    sel: null, // @Specific GRID et PIVOT mémorisation de la clé de sélection
    shd: false, // pas de colonne de suppression
    showF: true, // afficher les filtres
    shrd: false, // pas de suppression récursive des enfants
    shs: false, // pas de colonne de sélection
    shsu: false, // sélection unique
    sort: null, // @Specific GRID et PIVOT mémorisation du sort global (JSON)
    tv: 0, // version = 0
    v: null, // clé vision
    vs: null, // clé visionStep
    vsp: null, // clé visionStepPerimeter
    xlsC: false, // pas de création par dépose Excel
    xlsU: false, // pas d'update par dépose Excel
    xlsSheet: null, // nom de la feuille excel
    xlsNusc: false, // pas d'unicité sur les shortCodes
    mem: 1, // saisie en masse, popUP (2 = clone, 3 = split)
    scenOn: false, // scenario actif
    scenCode: null, // code du scenario en cours
    scenX: false, // pas en mode scenarii multiples dans les lignes
    scenUM: false, // modif possible du scenario par les users
    scenLbl: false, // affichage du libellé du scenario en cours pour le widget
    massDel: false, // suppression en masse pour les Freedatas
    cnx: null, // fonctions connect associées au widget
    stot: false, // afficher la ligne de total sur les grids
    revert: false, // inversion lignes et colonnes
    cm: null, // mode COMPUTE pour les calculs
    cmp: 0, // page en cours pour compute
    cms: 100, // taille de page pour compute,
    noUserFilter: false, // pas de filtre utilisateur
    expPDF: false, // export Excel interdit
    expXLS: false, // export PDF interdit
    pmdex: false, // mode gigogne avec détail
    pmdexParams: null,
    hsty: null, // style par défaut pour les headers
    showR: true, // afficher la liste
    showC: true, // afficher création
    showD: true, // afficher delete
    rowHeight:null, // forcer la taille des lignes du pivot 
    headerHeight:null, // forcer la taille des headers du pivot 
    gatling: false, // mode rafale pour les formulaires,
    hidden: false, // widget masqué
    targetPlace: null, // autre emplacement MENU | RIGHTP
    radius: null, // arrondi
    borderColor: null // couleur de bordure si pas de contour widget
  };
}


/** conf par défaut d'un élément de widget */
export function getDefaultWidgetConfigurationItemObj(): WidgetConfigurationItemObj  {
  return {
    agg: null, // fonction d'aggrégat pour le mode pivot
    casiz: true, // colonne redimensionnable, par défaut
    cauto: false, // taille auto pour la colonne
    cmsiz: null, // taille min de la colonne
    cod: null, // itemCode le code de la key, filterKey ou measure
    cols: null, // gridster largeur
    csiz: null, // taille de la colonne
    csty: null, // CSS pour les cellules
    fdCol: false, // premier colonne de data permanente (groupe de cols)
    fdvSearch: null, // code des champs affichés, séparés par | pour affichage & recherche dans la popUp de sélection
    fdvf: null, // champ éventuel à prendre sur un FDV à la place du shortCode
    filtExp: null, // comparateur#expression pour filtres numériques
    filtHide: false, // masque le filtre pour les users
    filtOnEx: false, // afficher uniquement les valeurs existantes dans le filtre
    fmt: null, // code du format de donnée
    hsty: null, // CSS pour le header
    lbl: null, // le libellé du champ
    moreF: null, // gridster subField (FD) ou fullCode (BL)
    ord: 0, // order l'indice de position de l'item dans sa collection
    pgrp: null, // code de la colonne parente pour les grid
    pin: null, // le champ est punaisé à gauche
    rdr: null, // renderer TODO. classFactory pour le rendu
    ro: false, // colonne éditable en readOnly
    rows: null, // gridster hauteur
    sel: null, // selectedItems collection de clés séparées par |, pour les éléments de filtres
    slbl: true, // afficher le libellé (mode form)
    sord: 0, // ordre de la clé de tri (en cas de tris multi-colonnes)
    sty: null, // styleCode. Code CSS & rules pour la mise en forme conditionnelle
    sway: null, // type de sort, soit '', soit asc soit desc
    x: null, // gridster coord X
    y: null, // gridster coord Y
    cella:null, // alignement des cellules
    heada:null, // alignement des headers
    mems: false, // mode split en massEdit pour la colonne
    totAgg: null, // fonction pour les aggrégats des cumuls / total
    totAggM: null, // mesure spécifique pour les aggrégats des cumuls / total
    totFmt: null, // format pour les aggrégats des cumuls / total
    noc: false, // pas cloné en cas de clonage
    msty: null, // style par mesure
    exportable: true, // colonne exportable
    pmdexParams: null,

    headColorField: null, // champ de rendu de la couleur sur les header.pivot
    headSubField: null, // champ complémentaire sur les header.pivot
    masterRowStyle: null, // classe de style de la rowFunc pour les masterLines (pmdMode)
    fieldSettings: null, // surcharge du rendu (workcom)
    hiddenCol: false, // colonne masquée
    headInherit: false, // hériter du rendu
    mandatory: false, // champ obligatoire (filtre)

    fullCode: null, // DEPRECATED
    subField: null, // DEPRECATED
  };
}

/** filtre mirroir dans la barre de menu */
export interface MirrorFilters  {
  widget: IWidget; // widget source
  filters: Map<string, IWidgetFilter>; // les filtres
  targetPlace: string; // l'emplacement cible
}



/** coordonnées de la dernière cellule ayant le focus, pour éventuel reprise en cas de création de Baseline */
export interface PivotFocusedCell  {
  pivotUID: string; // ID unique du pivot ayant le focus
  focusedCell: CellPosition; // coords de la cellule
  wl?: WidgetLine; // widgetline, pour fix sur retour de commit
  fdv?: FreedataValueVO; // en cas d'édition de FDV
  pce: PivotCellEditor; // l'éditeur ouvert, pour forcer son refresh
}

export interface FastSelectData {
  fei: FeiVO,
  kind: string, // type global d'objet (FREEDATA, BASELINE)
  date?: number, // date cible
  data: any // FDV ou WidgetLine, à caster
}

/**
 * collecte des éléments sur un master, pour filter et transmission à compute
 */
export interface MasterKeys {
  level: number, // le level du master
  keys: string[] // les clés de baseline OK
}


/** gestion des interactions de widgets */
export class WidgetEngine {

  protected _model: Model = null;
  public get model(): Model {
    return this._model as Model;
  }

  constructor(model: Model) {
    this._model = model;
  }



  /** prise de la dernière cellule ayant le focus pour reprise correcte sur AddBaseline (par créa / delete scenar) */
  public lastFocusedCell: PivotFocusedCell = null;

  /** contrôle sur addBaseline. Si j'ai perdu le focus sur une cellule, je lui redonne */
  public imLastFocus(widget: IWidget): boolean {
    if(!this.lastFocusedCell) { // pas d'ancien focus
      return false;
    }
    
    if(this.lastFocusedCell.pivotUID !== widget.uid) { // pas même widget
      return false;
    }

    return true; // oui, c'est moi
  }


  // map des gridsterItemVO alimentée par le template ou le userTab pour identifier les masters / slaves
  // donne l'ensemble des widgets dispos, par UUID
  private _widgetConfigMap: Map<string, GridsterWidget> = null;

  // un globalFilter identifié
  public globalFilter: GridsterWidget = null;
  // les codes scenar autorisés dans le globalFilter (pour alimentation AVANT la finalisation du composant)
  public globalScenarii: Set<string> = new Set();


  /**
   * retourne les valeurs disponibles sur le globalFilter pour filtrer les éléments de codif(ddext, valeur @@GLOBAL@@)
   * sous la form Fd#lvl = [shortcode...]
   */
  public get globalFilterKeys(): Map<string, Set<string>> {

    let result: Map<string, Set<string>> = new Map();
    // contrôle par filtre global
    if(!!this.model.widgetEngine.globalFilter) { 
      let globalFilter: IWidget = this.checkGlobalFilter();
      if(globalFilter.filters) { // filtre actifs sur le global
        let filter: IWidgetFilter; // les filtres qu'on va jouer

        for (var i = 0, len = globalFilter.filters.size; i < len; i++) {
          filter = [...globalFilter.filters.values()][i];
          if (filter.active) {
            result.set(filter.fkd.fullCode, filter.values);
          }
        }
      }
    }
    return result;
  }

  /**
   * alimentation de la pile de tags
   * @param tags 
   */
  private feedTags(tags: object): void {
    Object.keys(tags || {}).forEach(key => {
      let shortCodes: Set<string> =  new Set(tags[key]); // on a stocké des shortCodes
      let codes: Set<string> = new Set(); // mais on veut des codes 
      let parts: any[] = key.split(WizConstants.CONTEXT_SEPARATOR);

      // le FD cible
      let fd: FreeDataVO = this.model.freedataEngine.getFreeData(parts[0]);
      
      if(fd) {
        // on regarde s'il n'y a pas un arg
        let subParts: any[] = parts[1].split(WizConstants.FD_PARTS_SEPARATOR);
        
        if(subParts.length > 1) {// c'est bien un args. On le collecte

          let arg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(parts[0], subParts[1]);
          // on corrige les parts pour prendre le arg du FD
          let argParts = arg.datas.split(WizConstants.CONTEXT_SEPARATOR);

          // le FD du arg
          let argFD: FreeDataVO = this.model.freedataEngine.getFreeData(argParts[0]);
          let targetCode: Set<string> = new Set(); 
          let argFDVs: FreedataValueVO[];
          [...shortCodes.values() || []].forEach(fdvKey => {
            argFDVs = argFD.getFreeDataValueByShortCode(fdvKey);
            if(argFDVs?.length > 0) {
              argFDVs.forEach(fdvo => {
                if(fdvo.level === Number(argParts[1]))
                  targetCode.add([argParts[0],fdvo.code].join(WizConstants.CONTEXT_SEPARATOR));
              });
            }
          });

          // TODO ici, on boucle sur l'ensemble des FDV du FD pour le level cible
          let realKey: string = [parts[0], subParts[0]].join(WizConstants.CONTEXT_SEPARATOR);
          let fdvs: FreedataValueVO[] = this.model.freedataEngine.getFreedataValuesByLevel(realKey);
          fdvs.forEach((candidate: FreedataValueVO) => {
             let argVal: any = this.model.freedataEngine.getFDValue(candidate, argParts[0]);
             // console.log('argg', argVal);
             if(targetCode.has(argVal)) {
              codes.add(candidate.code);
             }
          });

          this._userGlobalFilterMap.set(realKey, codes);
          // on ajoute la forme simple pour les filtres des grid / tile FDV
          // on ajoute la forme simple pour les filtres des grid / tile FDV
          let fullSet: Set<string>  = new Set();
          let smallPart: string = realKey.split(ViewData.CONTEXT_SEPARATOR)[0];
          [...codes.keys()].forEach(s => {
            fullSet.add([smallPart, s].join(ViewData.CONTEXT_SEPARATOR));
          });
          this._userGlobalFilterMap.set(smallPart, fullSet);


        } else { // recherche simple, pas de args

          let fdvs: FreedataValueVO[];
          [...shortCodes.values() || []].forEach(fdvKey => {
            fdvs = fd.getFreeDataValueByShortCode(fdvKey);
            if(fdvs?.length > 0) {
              fdvs.forEach(fdvo => {
                if(fdvo.level === Number(parts[1]))
                codes.add(fdvo.code);
              });
            }
          });
          this._userGlobalFilterMap.set(key, codes);

          // on ajoute la forme simple pour les filtres des grid / tile FDV
          let fullSet: Set<string>  = new Set();
          let smallPart: string = key.split(ViewData.CONTEXT_SEPARATOR)[0];
          [...codes.keys()].forEach(s => {
            fullSet.add([smallPart, s].join(ViewData.CONTEXT_SEPARATOR));
          });
          this._userGlobalFilterMap.set(smallPart, fullSet);

        }

        
      }
    });
  }

  /**
   * gestion des restrictions globales par param user / param userApplication.app
   * key = FD#level = Set(FEV.code)
   */
  private _userGlobalFilterMap: Map<string, Set<string>> = null;
  public  get userGlobalFilter(): Map<string, Set<string>> {
    if(!this._userGlobalFilterMap) {
      let app: UserApplicationVO = this.model.userEngine.getUserAppFromMap(this.model.connectedUser,
      this.model.domainCode, this.model.businessUnitCode, this.model.visionCode,
      'APP');
      

      this._userGlobalFilterMap = new Map();
      if(app) {
        this.feedTags(app.tags);
      } 
      
      // alimentation des tags depuis les profiles du user
      let user: UserVO = this.model.connectedUser;
      user.userApplicationsVO.forEach(app => {
        if(app.businessUnitCode === this.model.businessUnitCode && 
        app.visionCode === this.model.visionCode) {
          if(app.profiles?.length > 0) {
            app.profiles.forEach(prof => {
              this.feedTags(prof.tags);
            });
            
          }
          // console.log('got you', app);
        }
      });
    }

    return this._userGlobalFilterMap;
  }


  /**
   * reset du filtre global sur modif des roles / profils / changement de vision
   */
  public  resetUserGlobalFilter(): void {
    this._userGlobalFilterMap = null;
  }

  /**
   * accesseur sur le set de champs utilisés par le globalFilter,
   * Marche aussi pour contrôler les filtres d'un MASTER
   * SANS les notions de niveau !!
   * @param widget (le global ou un master)
   * @return le set des champs utilisés en filtre, SANS les niveaux hiérarchiques
   */
  public  checkFilterSet(widget: IWidget): Set<string> {
    let globalSet: Set<string> = new Set();
    if(!!widget?.filters) {
      widget.filters.forEach((filter: IWidgetFilter) => {
        //if(filter.active) { // pas actif, aucun dégat possible pour les colonnes
        // malheureusement non, sinon, pas de détection du clearFilter
        if(filter.wcio.cod === ViewData.FILTER_GENERIC) {
          globalSet.add(ViewData.FILTER_GENERIC);
        } else if(filter.wcio.cod === ViewData.FILTER_ME) {
          globalSet.add(ViewData.FILTER_ME);
        } else {
          globalSet.add(filter.fkd.code);
        }
        
        // }
      });
    }

    return globalSet;
  }


  /**
   * alimentation de filtre global, soit sur init de la vue, soit par ajout du widget
   * @param wid 
   */
  public  feedGlobalFilter(wid: GridsterWidget): void {
    this.globalFilter = wid;
    // on alimente tout de suite les scenars si un filtre existe
    // console.log('gf', wid);
    wid.wco?.f?.forEach(wcio => {
      if(wcio.cod === WizConstants.SCEN_KEY_CODE && wcio.sel) {
        this.globalScenarii = new Set(wcio.sel.split(WizConstants.KEY_SEPARATOR));
      }
    });
  }

  /**
   * alimentation de la map de widgets depuis la vu e templating ou la vue user
   * on isole le filtre global (c'est aussi le scenar global)
   */
  public set widgetConfigMap(map: Map<string, GridsterWidget>)  { 
    // console.log('widgetConfigMap', map);
    this._widgetConfigMap = map;
    this.globalFilter = null; // on rince le filtre global éventuel
    this.globalScenarii = new Set();
    if(!!map) {
      [...map.values()].forEach((wid: GridsterWidget) => {
        if(wid.kind === WIDGET_KIND.GLOBAL_FILTER) { // ajout d'un globalFilter
          this.feedGlobalFilter(wid);
        }
      });
    }
  }

  /**
   * vue templating, ajout / suppression de widget
   * permet la gestion du globalFilter
   * @param action 
   * @param uid 
   * @param widget 
   * @returns 
   */
  public  alterWidgetConfigMap(action: EM_ACTION, uid: string, widget?: GridsterWidget ): void {  
    if(action === EM_ACTION.CREATE) {
      this._widgetConfigMap.set(uid, widget);
    } else if (action === EM_ACTION.DELETE) {
      this._widgetConfigMap.delete(uid);
      if(this.globalFilter && this.globalFilter.uid === uid) { // suppression du global filter
        this.globalFilter = null;
        this.submitGlobalScen(new Set()); // on rince le forçage de scenar
      }
    } 
    // console.log('alterWidgetConfigMap', action, widget, this.globalFilter);
  }


  /** soumission d'une pile de code scenar depuis le globalFilter (ou reset si suppression du globalFilter) */
  public  submitGlobalScen(newScens: Set<string>): void {
    // console.log('submitGlobalScen', newScens);
    this.globalScenarii = newScens;
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.GLOBAL_SCENAR_UPDATE, this));
  }

  /**
   * retourne la conf du widget correspondant à cet UID
   * @param uid ...
   * @returns le givo de conf du widget
   */
   public  getWidgetByUid(uid: string): GridsterWidget {
    let result: GridsterWidget = this._widgetConfigMap?.get(uid) || null;
    return result;
  }

  /** alimentation du titre par défaut sur choix */
  public  getDefaultTitle(wco: WidgetConfigurationObj): string {
    let result: string = WizTranslationManager.getInstance().translateKey('$.widget.title.default.new-item.$');
    if (!!wco) {
      if (!!wco.vs) {
        // datasource OK
        result = this.model.visionCode;
        const step: VisionStep = BaselineEngine.getVisionStepByLevel(this.model.currentVision, Number(wco.vs));
        if (step) {
          result = this.model.visionEngine.getVisionStepLabel(this.model.currentVision, step);
        }

      } else if (!!wco.fdk) {
        const fd: FreeDataVO = this.model.freedataEngine.getFreeData(wco.fdk.split(WizConstants.CONTEXT_SEPARATOR)[0])
        // FD OK
        result = fd?.trsLabel;
      } else if (wco.k) {
        // type OK
        result =  WizTranslationManager.getInstance().translateKey('$.widget.title.configuring.' + wco.k + '.$');
      }
    }
    return result;
  }

  /**
   * retourne les widgets valides comme master pour le widget cible
   * @param all le pool de widgets de la vue
   * @param me le widget en cours de configuration
   * @param step le step en cours de sélection pour le widget
   * @returns la liste valide
   */
  public  availableMasters(all: GridsterWidget[], me: GridsterWidget, step: VisionStep): GridsterWidget[] {
    const result: GridsterWidget[] = [];

    if (step) {
      // il faut qu'un visionStep soit défini sur le widget (TODO, synchroniser avec la saisie dans WidgetDataPop)
      all.forEach((m: GridsterWidget) => {
        let isOk: boolean = true; // on considère que c'est ok par défaut

        if (m.uid === me.uid) {
          // pas de self
          isOk = false;
        }

        if (isOk) {
          // pas de maître avec un step supérieur (level enfant)
          if (!m.visionStep || m.visionStep.level > step.level) {
            isOk = false;
          }
        }

        if (isOk) {
          // pas de maître avec un step supérieur (level enfant)
          const meKind: string = me.wco.k;
          const masterKind: string = m.wco.k;
          if (!this.masterKindMatch(meKind, masterKind)) {
            // adéquation de type
            isOk = false;
          }
        }
        if (isOk) {
          result.push(m);
        }
      });
    }

    // TODO attention aux cycles sur un même niveau (faire une suite, si boucle, non)

    return result;
  }

  /**
   * retourne les widgets valides comme master pour le widget cible pour les Widget FD
   * @param all le pool de widgets de la vue
   * @param me le widget en cours de configuration
   * @param key le FD.level
   * @returns la liste valide
   */
   public  availableFreedataMasters(all: GridsterWidget[], me: GridsterWidget, key: VisionKeyObj): GridsterWidget[] {
    const result: GridsterWidget[] = [];

    if (key) {
      // il faut qu'un visionStep soit défini sur le widget (TODO, synchroniser avec la saisie dans WidgetDataPop)
      all.forEach((m: GridsterWidget) => {
        let isOk: boolean = true; // on considère que c'est ok par défaut

        if (m.uid === me.uid) {
          // pas de self
          isOk = false;
        }

        if (m.freedataCode !== key.baseCode) {
          // pas même codif
          isOk = false;
        }

        if (isOk) {
          // pas de maître avec un step supérieur (level enfant)
          if (m.freedataLevel > key.level) {
            isOk = false;
          }
        }

        if (isOk) {
          const meKind: string = me.wco.k;
          const masterKind: string = m.wco.k;
          if (!this.masterKindMatch(meKind, masterKind)) {
            // adéquation de type
            isOk = false;
          }
        }

        if (isOk) {
          result.push(m);
        }
      });
    }

    // TODO attention aux cycles sur un même niveau (faire une suite, si boucle, non)

    return result;
  }


  /** map[ type esclave potentiel] = Map [type maître] = string */
  private masterMatchMap: Map<string, Set<string>> = null;
  /**
   * construction de la map des cas possibles d'asservissement maitre = esclave
   */
  private feedMasterMatchMap(): void {
    const res: Map<string, Set<string>> = new Map<string, Set<string>>();

    res.set(WIDGET_KIND.FORM, new Set<string>()); // gestion des maîtres possibles du formulaire
    // res.get(WIDGET_KIND.FORM).add(WIDGET_KIND.PIVOT); // attendre la création du form de saisie en masse
    res.get(WIDGET_KIND.FORM).add(WIDGET_KIND.GRID); // en mode sélection unique
    res.get(WIDGET_KIND.FORM).add(WIDGET_KIND.PIVOT);
    res.get(WIDGET_KIND.FORM).add(WIDGET_KIND.CALENDAR);
    res.get(WIDGET_KIND.FORM).add(WIDGET_KIND.TILE);
    // res.get(WIDGET_KIND.FORM).add(WIDGET_KIND.LIST); // attendre la création du form de saisie en masse

    res.set(WIDGET_KIND.CHART, new Set<string>()); // gestion des maîtres possibles des charts
    res.get(WIDGET_KIND.CHART).add(WIDGET_KIND.PIVOT);
    res.get(WIDGET_KIND.CHART).add(WIDGET_KIND.GRID); // en mode sélection multi ?
    res.get(WIDGET_KIND.CHART).add(WIDGET_KIND.TILE);

    res.set(WIDGET_KIND.LIST, new Set<string>()); // gestion des maîtres possibles des listes
    res.get(WIDGET_KIND.LIST).add(WIDGET_KIND.PIVOT);
    res.get(WIDGET_KIND.LIST).add(WIDGET_KIND.GRID); // en mode sélection multi ?

    res.set(WIDGET_KIND.CALENDAR, new Set<string>()); // gestion des maîtres possibles des calendriers
    res.get(WIDGET_KIND.CALENDAR).add(WIDGET_KIND.PIVOT);
    res.get(WIDGET_KIND.CALENDAR).add(WIDGET_KIND.GRID); // en mode sélection multi ?
    res.get(WIDGET_KIND.CALENDAR).add(WIDGET_KIND.TILE);

    res.set(WIDGET_KIND.GRID, new Set<string>()); // gestion des maîtres possibles des grids simples
    res.get(WIDGET_KIND.GRID).add(WIDGET_KIND.PIVOT);
    res.get(WIDGET_KIND.GRID).add(WIDGET_KIND.GRID); // en mode sélection multi ?
    res.get(WIDGET_KIND.GRID).add(WIDGET_KIND.CALENDAR); // en mode sélection multi ?
    res.get(WIDGET_KIND.GRID).add(WIDGET_KIND.TILE);

    res.set(WIDGET_KIND.PIVOT, new Set<string>()); // gestion des maîtres possibles des pivots
    res.get(WIDGET_KIND.PIVOT).add(WIDGET_KIND.GRID);
    res.get(WIDGET_KIND.PIVOT).add(WIDGET_KIND.PIVOT);
    res.get(WIDGET_KIND.PIVOT).add(WIDGET_KIND.CALENDAR); // en mode sélection multi ?
    res.get(WIDGET_KIND.PIVOT).add(WIDGET_KIND.TILE);

    res.set(WIDGET_KIND.TIMELINE, new Set<string>()); // gestion des maîtres possibles pour les timelines
    res.get(WIDGET_KIND.TIMELINE).add(WIDGET_KIND.GRID);
    res.get(WIDGET_KIND.TIMELINE).add(WIDGET_KIND.PIVOT);
    res.get(WIDGET_KIND.TIMELINE).add(WIDGET_KIND.CALENDAR);
    res.get(WIDGET_KIND.TIMELINE).add(WIDGET_KIND.TILE);

    res.set(WIDGET_KIND.TILE, new Set<string>()); // gestion des maîtres possibles des tuiles FDV
    res.get(WIDGET_KIND.TILE).add(WIDGET_KIND.TILE);
    res.get(WIDGET_KIND.TILE).add(WIDGET_KIND.GRID);

    res.set(WIDGET_KIND.FD_CALENDAR, new Set<string>()); // gestion des maîtres possibles des calendars FDV
    res.get(WIDGET_KIND.FD_CALENDAR).add(WIDGET_KIND.FD_GRID);
    res.get(WIDGET_KIND.FD_CALENDAR).add(WIDGET_KIND.FD_TILE);

    res.set(WIDGET_KIND.FD_TIMELINE, new Set<string>()); // gestion des maîtres possibles des timelines FDV
    res.get(WIDGET_KIND.FD_TIMELINE).add(WIDGET_KIND.FD_GRID);
    res.get(WIDGET_KIND.FD_TIMELINE).add(WIDGET_KIND.FD_TILE);

    res.set(WIDGET_KIND.FD_FORM, new Set<string>()); // gestion des maîtres possibles des formulaires FDV
    res.get(WIDGET_KIND.FD_FORM).add(WIDGET_KIND.FD_GRID);
    res.get(WIDGET_KIND.FD_FORM).add(WIDGET_KIND.FD_TILE);

    res.set(WIDGET_KIND.FD_GRID, new Set<string>()); // gestion des maîtres possibles des grids FDV
    res.get(WIDGET_KIND.FD_GRID).add(WIDGET_KIND.FD_GRID);
    res.get(WIDGET_KIND.FD_GRID).add(WIDGET_KIND.FD_TILE);

    res.set(WIDGET_KIND.FD_TILE, new Set<string>()); // gestion des maîtres possibles des tuiles FDV
    res.get(WIDGET_KIND.FD_TILE).add(WIDGET_KIND.FD_TILE);
    res.get(WIDGET_KIND.FD_TILE).add(WIDGET_KIND.FD_GRID);


    this.masterMatchMap = res;
  }

  /**
   * retour le master éventuel pour un widget
   * @param widget demandeur
   * @returns l'instance Iwidget du master, si existe
   */
  public checkMasters(widget: IWidget): Map<string, IWidget> {
    let masters: Map<string, IWidget> = null;
    if(!!widget.context?.muid) {
      masters = new Map();
      let splitted: string[] = widget.context.muid.split(WizConstants.KEY_SEPARATOR);
      splitted.forEach(s => {
        masters.set(s, this.getWidgetByUid(s)?.instance);
      });
      // master = this.getWidgetByUid(widget.context.muid)?.instance || null;
    }
    return masters;
  }

  public checkFirstMaster(widget: IWidget): IWidget {
    let master: IWidget = null;
    if(!!widget.context?.muid) {
      let splitted: string[] = widget.context.muid.split(WizConstants.KEY_SEPARATOR);
      master = this.getWidgetByUid(splitted[0])?.instance;
    }
    return master;
  }


  /**
   * retour l'instance de filtre global s'il existe
   * @returns l'instance Iwidget du filtre global, si existe
   */
  public  checkGlobalFilter(): IWidget {
    if(!!this.globalFilter) { // 
      return this.globalFilter.instance || null;
    }
    return null;
  }

  /**
   * comparaison du type du widget cible et de son maître potentiel, pour supprimer les cas incohérents (form vers pivot...)
   * @param meKind l'esclave cible
   * @param masterKind le maître souhaité
   * @returns true si le maître peut l'accepter
   */
  public masterKindMatch(meKind: string, masterKind: string): boolean {
    let result: boolean = false; // on part du principe que non
    if (!this.masterMatchMap) {
      this.feedMasterMatchMap();
    }
    if (this.masterMatchMap.get(meKind)?.has(masterKind)) {
      result = true;
    }
    return result;
  }



  /**
   * collecte des clés disponibles sur un master, et son level
   * @param widget 
   */
  public feedMasterKeys(widget: IWidget): MasterKeys {
    let result: MasterKeys = null;
    let master: IWidget = this.getWidgetByUid(widget.context?.muid)?.instance;
    if (master?.mainDS.selectedItems?.length > 0) {
      // une sélection
      result = {level: master.visionStep.level, keys: []};

      master.mainDS.selectedItems.forEach((mpl: WidgetLine) => {     
        [...mpl.ch.values()].forEach(wl => {
          result.keys.push(wl.bl.key);
        });
      });
    }
    return result;
  }

  /**
   * retourne les éléments sélectionnés sur un masterWidget
   * @param widget 
   * @returns 
   */
  public getMasterSelected(widget: IWidget): WidgetLine[] {
    let result: WidgetLine[] = null; // les lignes sélectionnées sur le master
    let master: IWidget = this.getWidgetByUid(widget.context?.muid)?.instance;

    if (!!master?.mainDS.selectedItems && master.mainDS.selectedItems.length > 0) {
      result = [...master.mainDS.selectedItems];
    }
    return result;
  }

  /**
   * construction du pool de données d'un widget esclave
   * @param widget l'esclave
   * @param pool les données possibles (le pack complet rows du FEI)
   * @returns le pool de WidgetLine autorisées
   */
  public availableMasterLines(widget: IWidget,  pool: WidgetLine[]): WidgetLine[] {
    
    // prise en compte des scenars...
    let context: WidgetConfigurationObj = widget.context; 
    let result: WidgetLine[] = []; // les lignes autorisées
    const parentPool: WidgetLine[] = []; // les lignes du maître
    let masterLinesMap: Map<string, WidgetLine> = new Map<string, WidgetLine>(); // les baselines du parent, si step différents

    let master: IWidget = this.getWidgetByUid(widget.context?.muid)?.instance;

    if (!!master?.mainDS.selectedItems && master.mainDS.selectedItems.length > 0) {
      // une sélection
      master.mainDS.selectedItems.forEach((mpl: WidgetLine) => {
        if(!!mpl.ch) {
          parentPool.push(...mpl.ch.values());
        } else {
          parentPool.push(mpl);
        }
        
      });
    } else {
      // sinon on prend tout le pool du parent (il est potentiellement asservi lui-même à un widget)
      // selon le mode tout ou rien défini dans la DS
     if (!!context?.mefe) {
      return result; // retour à vide
     } else {
      master.mainDS.getWorkedSource().forEach((mpl: WidgetLine) => {
        if(!!mpl.ch) {
          parentPool.push(...mpl.ch.values());
        } else {
          parentPool.push(mpl);
        }
      });
     }
    }

    if (master.visionStep.level === widget.visionStep.level) {
      // même level, prendre en compte les scenars
      if(master.fei.scenario === widget.fei.scenario) {
        result = parentPool; // on prend les lignes du base actives pour le parent
      } else { // pas le même scenar, faut comparer clé à clé (on est sur le même niveau)
        // scenar différent, il faut comparer les clés
        masterLinesMap = new Map(parentPool.map((wl: WidgetLine) => [wl.bl.key, wl]));
        
        pool.forEach((wl: WidgetLine) => {
          if (masterLinesMap.has(wl.key)) {
            result.push(wl);
          }
        });
      }
      
    } else {
      // level supérieur, il faut comparer les clés
      masterLinesMap = new Map(parentPool.map((wl: WidgetLine) => [wl.bl.key, wl]));
      const masterKeySize: number = BaselineEngine.getStepKeys(master.vision, master.visionStep).length;
      const slaveKeySize: number = BaselineEngine.getStepKeys(widget.vision, widget.visionStep).length;
      const delta = slaveKeySize - masterKeySize;

      pool.forEach((wl: WidgetLine) => {
        // prise en compte du niveau
        let refKey: string = wl.bl.key;
        if (delta > 0) {
          // sur step différents, raccourcir la clé sur split "|"
          refKey = refKey.split(WizConstants.KEY_SEPARATOR).slice(0, masterKeySize).join(WizConstants.KEY_SEPARATOR);
        }
        if (masterLinesMap.has(refKey)) {
          result.push(wl);
        }
      });
    }
    return result;
  }

  /**
   * recherche de parent unique pour la création de FDV de niveau > 1
   * @param fdv en cours de création
   * @param widget cible pour recherche du pool parent si existe. Peut être de même niveau ou level inférieur. Peut être null et posséder un master lui aussi
   * @returns un parent unique identifié
   */
  public  findMasterParentUnicity(widget: IFreedataWidget): FreedataValueVO {
    let result: FreedataValueVO = null;
    
    const widgetLevel: number = widget.level;

    if (widgetLevel === 1) { // inutile sur level1, pas de parent
      // console.log("fdv level 1 return");
      return null;
    }

    let masterPrototype: IWidget = this.checkFirstMaster(widget);
    if(!!masterPrototype) {
      let masterPool: FreedataValueVO[] = [];
      // console.log('FD master', masterPrototype);
      let master: IFreedataWidget = masterPrototype as IFreedataWidget;
      if (!!master?.fdvDS.selectedItems && master.fdvDS.selectedItems.length > 0) { // sélection sur le master
        masterPool = master.fdvDS.selectedItems;
      } else { // pas de sélection sur le master
        masterPool = master?.fdvDS.getSource();
      }

      // maintenant, on compare les levels... Si masterPool est inférieur, faut comparer les clés de code
      if(master.level === widget.level) {
      } else {
        let currentLevel: number = master.level;
        let currentKeySet: Set<string> = new Set(masterPool.map(item => item.code));
        // let nextPool: FreedataValueVO[] = [];

        while (currentLevel < widget.level -1) {
          currentLevel++;
          let nextLvlKey: string = [widget.freedataCode, currentLevel].join(WizConstants.CONTEXT_SEPARATOR);
          masterPool = this.model.freedataEngine.getFreedataValuesByLevel(nextLvlKey)?.filter(item => currentKeySet.has(item.parentCode));
          currentKeySet = new Set(masterPool.map(item => item.code));
        };
      }
      if(masterPool.length === 1) {
        result = masterPool[0];
      }
    } 
    return result;
  }

  /**
   * construction du pool de données d'un widget esclave pour les FREEDATA
   * @param widget l'esclave
   * @param master le maître
   * @param targetFD code#level du FD utilisé sur l'esclave
   * @param pool les données possibles (le pack complet rows du FEI)
   * @returns le pool de WidgetLine autorisées
   */
  public availableFreedataMasterLines(widget: IWidget, master: IFreedataWidget, targetFD: string,  pool: FreedataValueVO[]): FreedataValueVO[] {
    
    // prise en compte des scenars...
    let context: WidgetConfigurationObj = widget.context; 
    let result: FreedataValueVO[] = []; // les lignes autorisées

    let freedataCode: string = targetFD.split(WizConstants.CONTEXT_SEPARATOR)[0];
    let level: number = Number(targetFD.split(WizConstants.CONTEXT_SEPARATOR)[1]);


    // on recherche le master
      let masterPool: FreedataValueVO[] = [];
      // console.log('FD master', masterPrototype);
      if (!!master?.fdvDS.selectedItems && master.fdvDS.selectedItems.length > 0) { // sélection sur le master
        masterPool = master.fdvDS.selectedItems;
        // console.log('masterPool', masterPool);
      } else { // pas de sélection sur le master
          // sinon on prend tout le pool du parent (il est potentiellement asservi lui-même à un widget)
        // selon le mode tout ou rien défini dans la DS
        if (!!context?.mefe) {
          // rien à faire return result; // retour à vide, le master est vide...
        } else {
          masterPool = master?.fdvDS.getSource();
        }
      }

      // maintenant, on compare les levels... Si masterPool est inférieur, faut comparer les clés de code
      if(master.level === level) {
        // problème sur refresh si le master n'est pas encore mis à jour
        let currentKeySet: Set<string> = new Set(masterPool.map(item => item.code));
        result = pool?.filter(item => currentKeySet.has(item.code));
      } else {
        let currentLevel: number = master.level;
        let currentKeySet: Set<string> = new Set(masterPool.map(item => item.code));
        // let nextPool: FreedataValueVO[] = [];

        while (currentLevel < level -1) {
          currentLevel++;
          let nextLvlKey: string = [freedataCode, currentLevel].join(WizConstants.CONTEXT_SEPARATOR);
          masterPool = this.model.freedataEngine.getFreedataValuesByLevel(nextLvlKey)?.filter(item => currentKeySet.has(item.parentCode));
          currentKeySet = new Set(masterPool.map(item => item.code));
        };

        result = pool?.filter(item => currentKeySet.has(item.parentCode));
      }
      
    return result;
  }


  /** construction d'un Wcio */
  public  newWcio(cod: string, // itemCode le code de la key, filterKey ou measure
                        ord: number, // order l'indice de position de l'item dans sa collection
                        agg?: string, // fonction d'aggrégat pour le mode pivot
                        rdr?: any, // renderer TODO. classFactory pour le rendu
                        sty?: string, // styleCode. Code CSS & rules pour la mise en forme conditionnelle
                        sel?: string, // selectedItems collection de clés séparées par |, pour les éléments de filtres
                        pin?: string, // le champ est punaisé à gauche
                        hsty?: string, // CSS pour le header
                        fmt?: string, // code du format de donnée
                        casiz?: boolean, // colonne redimensionnable, par défaut
                        cmsiz?: number, // taille min de la colonne
                        csiz?: number, // taille de la colonne
                        fdvf?: string, // champ éventuel à prendre sur un FDV à la place du shortCode
                        fdvSearch?: string, // code des champs affichés, séparés par | pour affichage & recherche dans la popUp de sélection
                        csty?: string, // CSS pour les cellules
                        ro?: boolean  // colonne éditable en readOnly
                        ): WidgetConfigurationItemObj {
      let result: WidgetConfigurationItemObj = getDefaultWidgetConfigurationItemObj();
      result.cod = cod;
      result.ord = ord;
      result.agg = agg;
      result.rdr = rdr;
      result.sty = sty;
      result.sel = sel;
      result.pin = pin;
      result.hsty = hsty;
      result.fmt = fmt;
      result.casiz = casiz;
      result.cmsiz = cmsiz;
      result.csiz = csiz;
      result.fdvf = fdvf;
      result.fdvSearch = fdvSearch;
      result.csty = csty;
      result.ro = !!ro;
      return result;
    }

  /**
   * init des arrays du wco
   *
   */
   public  wcioInitArrays(wco: WidgetConfigurationObj): void {
    wco.r = [];
    wco.c = [];
    wco.f = [];
    wco.d = [];
    wco.i = [];
    wco.g = [];
  }

  /**
   * alimentation des params de colonnes: taille
   * @param casiz colonne redimensionnable
   * @param cmsiz taille min de la colonne
   * @param csiz taille de la colonne
   * @param exportable (non) exportable
   * @param hidden colonne masquée
   *
   */
  public  wcioColParams(wcio: WidgetConfigurationItemObj, casiz?: boolean, cmsiz?: number, csiz?: number, exportable?: boolean, hidden?: boolean): void {
    wcio.casiz = casiz;
    wcio.cmsiz = cmsiz;
    wcio.csiz = csiz;
    wcio.exportable = exportable;
    wcio.hiddenCol = hidden;
  }

  /**
   * alimentation des params de colonnes: format style
   * @param fmt le code du format de données
   * @param sty la configuration de style conditionnel
   * @param hsty le style du header
   * @param csty style par défaut pour les cellules
   * @param headColorField champ de rendu background
   * @param headSubField champ sous-titre de la colonne
   */
  public  wcioStyleParams(wcio: WidgetConfigurationItemObj, fmt?: string, sty?: string, 
    hsty?: string, csty?: string, 
    headColorField?: string, headSubField?: string): void {
    wcio.sty = sty;
    wcio.hsty = hsty;
    wcio.csty = csty;
    wcio.fmt = fmt;
    wcio.headColorField = headColorField;
    wcio.headSubField = headSubField;
  }

  /**
   * alimentation des params de colonnes sur wcio : tri
   * @param sway sens du tri
   * @param sord ordre dans la pile de tri
   */
  public  wcioSortParams(wcio: WidgetConfigurationItemObj, sway?: string, sord?: number): void {
    wcio.sway = sway;
    wcio.sord = sord;
  }


  /**
   * utilitaire. Sépare le champ de sa sous-propriété pour les FDV
   * genre CLI#shortCode => [CLI, shortCode]
   * @param fdvf 
   */
  public  fdvfSplitter(fdvf: string): [string, string] {
    let fieldPart: string[] = fdvf?.split(WizConstants.FD_PARTS_SEPARATOR) || []; // on prend le code du FD
    let realField: string = null;
    let realProperty: string = null;
    if(fieldPart.length > 0) {
      realField = fieldPart[0];
    } if(fieldPart.length > 1) {
      realProperty = fieldPart[1];
    }
    return [realField, realProperty];
  }


  /* ##############################################################################
            construction d'un filtre symbolique pour un widget
     ############################################################################## */

  /**
   * construction des colonnes pour les popUps de filtres
   * @param filter: IWidgetFilter
   * @param moreFields champs complémentaires pour la recherche
   * par défaut, code + label
   * @returns la définition des colonnes
   */
  public  buildFilterColumns(filter: IWidgetFilter, sourceMoreFields: string[]): WizColDef[] {
    const result: WizColDef[] = [];
    let col: WizColDef;

    let moreFields: string[] = [WizConstants.FIELD_SHORT_CODE, WizConstants.FIELD_LABEL];

    if (!!filter.wcio.fdvSearch) {
      moreFields = filter.wcio.fdvSearch.split(WizConstants.KEY_SEPARATOR);
    }

    // correction en cas d'utilisation de champ non unique, pas d'affichage des moreFields
    let uniqueFields: string[] = [WizConstants.FIELD_CODE, WizConstants.FIELD_SHORT_CODE, WizConstants.FIELD_LABEL];
    
    if(filter.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE) { // pour les baselines & le globalFilter
      if(!!filter.wcio.fdvf && uniqueFields.indexOf(filter.wcio.fdvf) <= -1) {
         moreFields = [filter.wcio.fdvf];
      }
    }
    
    if(!filter.fkd.isFreedata) { // pas de champs complémentaires si ce n'est pas un Freedata
      moreFields = null;
    }


    let fd: FreeDataVO = null;
    const fdParts: string[] = filter.wcio.cod.split(WizConstants.CONTEXT_SEPARATOR); // on prend le code du FD
    fd = this.model.freedataEngine.getFreeData(fdParts[0]); // on le collecte
    let subFD: FreeDataVO = null; // éventuel sous-FD
    let moreArgConstructors: Map<string, FreedataArgsVO> = null; // structure de construction des args supplémentaires pour le rendu pop
    let useSubFilter: boolean = false;

    if(!!filter.wcio.fdvf) { //  && filter.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.BASELINE) { // champ de rendu sur les FDVs. On va prendre la valeur éventuelle de la sous-codif
      if(filter.fkd.isFreedata) {

        let realField: string = this.fdvfSplitter(filter.wcio.fdvf)[0];
      
        let argMap: Map<string, FreedataArgsVO> = new Map(fd.allFieldsAsArgs.map(item => [item.code, item]));
        const arg: FreedataArgsVO = argMap.get(realField); // on regarde son args éventuel
        if (arg?.dataType === FIELD_KIND.OBJECT) { // c'est un subFD, on écrase le dataKind, et on alimente la map subFDV
          useSubFilter = true;
          subFD = this.model.freedataEngine.getFreeData(arg.datas.split(WizConstants.CONTEXT_SEPARATOR)[0]); // on le collecte
          // console.log('arg', arg, subFD);
        } else { // si je suis en mode Freedata le champ devient mon moreField
          if(filter.widget?.widgetGlobalKind === WIDGET_GLOBAL_KIND.FREEDATA) {
            // if(uniqueFields.indexOf(realField) <= -1) {
               moreFields = [realField];
            // }
          }
        }
      }
    } 
    if(!!moreFields) { // champs complémentaire pour la popUp de sélection
      if(useSubFilter) { // prise des args sur le subFDV
        // TODO non, pas pour les FDV, prendre searchFDV
        moreFields = [WizConstants.FIELD_SHORT_CODE, WizConstants.FIELD_LABEL];
        moreArgConstructors = new Map(subFD.allFieldsAsArgs.map(arg => [arg.code, arg]));
      } else { // sinon sur le FD
        moreArgConstructors = new Map(fd.allFieldsAsArgs.map(arg => [arg.code, arg]));
      }
    }

    if (!!moreFields) {
      const oneColl: boolean = moreFields.length === 1;
      moreFields.forEach(key => {
        const arg: FreedataArgsVO = moreArgConstructors?.get(key);
        if (arg) {
          col = {};
          col.headerName = arg.trsLabel;
          col.field = key;
          col.sortable = true;
          col.resizable = true;
          if (oneColl) {
            col.flex = 1;
          } else {
            col.width = !!arg.defaultSize && arg.defaultSize > 0 ? arg.defaultSize : 100;
          }
          col.tooltipField = key;
          col.datakind = arg.dataType;
          col.dataformat = arg.format;
          col.widget = filter.widget;
          col.valueFormatter = this.model.gridAccessors.fdArgFormattedAccessor;

                // gestion du rendu image pour les mesures
          if (col.datakind === FIELD_KIND.BINARY) {
            col.cellClass = 'grid-cell-centered';
            col.cellRenderer = this.model.gridAccessors.attachmentCellRender;
          }
          // pas un booléen éditable
          if (col.datakind === FIELD_KIND.BOOLEAN) {
            // mais un rendu booléen
            col.cellClass = 'cbox-cell';
            col.cellClass += ' no-edit';
            col.cellRenderer = WizAgGridUtils.CELL_CHECKBOX_RENDERER;
          }
          // TODO renderer
          result.push(col);
        }
      });
    } else {
      col = { headerName: '$.common.select.all.$',
              field: WizConstants.FIELD_LABEL,
              sortable: true,
              resizable: true,
              flex: 1,
              tooltipField: WizConstants.FIELD_LABEL};
      result.push(col);
    }

    if(moreFields) {
      moreFields.forEach(s => {
        sourceMoreFields.push(s);
      });
    } else {
      sourceMoreFields.push(WizConstants.FIELD_LABEL)
    }
    
    return result;
  }

  /**
   * construction d'un filtre pour les widgets
   * 
   * @param widget cible
   * @param wcio configuration du filtre
   * @returns IWidgetFilter
   */
  public buildFilter(widget: IWidget, wcio: WidgetConfigurationItemObj): IWidgetFilter {
    let fei: FeiVO = widget.fei as FeiVO;
    let fkd: FeiKeyDef = BaselineEngine.getKey(fei, wcio.cod);
    
    // le filtre en cours de construction
    let filter: IWidgetFilter = {widget, wcio, fkd, active: false, useSubs: false, useNonUnique: false, mandatory: !!wcio.mandatory};

    if (!!wcio.filtExp) { // filtre sur base d'expression
      // filter.active = true; // j'ai un filtre... même s'il fitre rien...
      filter.regex = wcio.filtExp;
      // filter.comparator = wcio.filtExp.split(ViewData.KEY_SEPARATOR)[0]; // on extrait le comparateur
    } else if(wcio.sel) { // ou filtre basé sur une sélection simple
      
      if(fkd?.datakind === FIELD_KIND.LIST) {
        filter.values = new Set(wcio.sel.split(WizConstants.DOUBLEKEY_SEPARATOR));
      } else {
        filter.values = new Set(wcio.sel.split(WizConstants.KEY_SEPARATOR));
      }
    }

    // alimentation des données volatiles
    this.refreshFilter(filter);

    return filter;
  }

  /**
   * alimentation des données volatiles sur le filtre
   * - données regex
   * - collection véritable en cas de subFD
   * @param filter 
   */
  public refreshFilter(filter: IWidgetFilter): void {
    // console.log('refreshFilter', filter);
    if(!filter) { // null si on force le refresh global sur GlobalFilter
      return;
    }

    // let fei: FeiVO = filter.widget.fei;
    let fkd: FeiKeyDef = filter.fkd;
    
    // on rince les données volatiles
    filter.active = false;
    filter.useSubs = false;
    filter.comparator = null;
    filter.regexOne = null;
    filter.regexTwo = null;
    filter.realValues = null;

    if(filter.wcio.cod === ViewData.FILTER_GENERIC) {
      filter.realValues = filter.values || new Set();
      filter.active = filter.realValues.size > 0;
    } else if(filter.wcio.cod === ViewData.FILTER_ME) {
      filter.realValues = filter.values || new Set();
      filter.active = filter.realValues.size > 0;
      // console.log('filter.realValues',filter.realValues);
    }
    else if (!!filter.regex) { // filtre sur base d'expression
      filter.active = true;
      let parts: any[] = filter.regex.split(WizConstants.KEY_SEPARATOR);
      filter.comparator = parts[0]; // on extrait le comparateur
      filter.regexOne = parts[1];
      filter.regexTwo = parts.length === 3 ? parts[2] : null;

    } else if(filter.values?.size > 0) { // ou filtre basé sur une sélection simple
      filter.active = true;
      
      if(fkd?.isScen) {
        // neutralisation
      } else if (filter.wcio.cod === ViewData.FILTER_GENERIC) {
        // neutralisation
      }
       else if (fkd.isFreedata && filter.values?.size > 0) { // seulement pour les FDs et on a aussi au moins un filtre
  
        const fdParts: string[] = filter.wcio.cod.split(WizConstants.CONTEXT_SEPARATOR); // on prend le code du FD
        let fd: FreeDataVO = this.model.freedataEngine.getFreeData(fdParts[0]); // on le collecte
        let realField: string = this.fdvfSplitter(filter.wcio.fdvf)[0];
        const arg: FreedataArgsVO = fd.getArgsVOMap().get(realField); // on regarde son args éventuel
        if (arg?.dataType === FIELD_KIND.OBJECT) { // c'est un subFD, on écrase le dataKind
          filter.useSubs = true;
        } 
        let uniqueFields: string[] = [WizConstants.FIELD_CODE, WizConstants.FIELD_SHORT_CODE, WizConstants.FIELD_LABEL];
        if(!!filter.wcio.fdvf && uniqueFields.indexOf(filter.wcio.fdvf) === -1) {
          filter.useNonUnique = true;
        }

        let realValues: Set<string> = new Set();
        let argVal: string; // la valeur de mon FDV pour l'arg qui est stocké dans le filtre
        if(filter.useSubs) {
          // on a stocké des valeurs sur le sous-FD
          // il faut trouver les FDVs de mon niveau qui possèdent comme arg ce FDV
          // ou alimenter la keypair sur les widgetlines ??
          this.model.freedataEngine.getFreedataValuesByLevel(filter.wcio.cod).forEach((fdv: FreedataValueVO)=> {
            argVal = fdv.argsObjVO[arg.code];
            if(!!argVal && filter.values.has(argVal.split(WizConstants.CONTEXT_SEPARATOR)[1])) {
              realValues.add(fdv.code);
            }
          });
          filter.realValues = realValues;
        } else if (filter.useNonUnique) {
          this.model.freedataEngine.getFreedataValuesByLevel(filter.wcio.cod).forEach((fdv: FreedataValueVO)=> {
            argVal = fdv.argsObjVO[realField];
            if(!!argVal && filter.values.has(argVal)) {
              realValues.add(fdv.code);
            }
          });
          filter.realValues = realValues;
        }
      }
    }
  }

  /**
   * filtre la map des FDVs pour les filtres de pivot, selon les restrictions sur le user
   * @param origin 
   * @returns le même, filtré
   */
  public  restrictFreedataMapFromUser(origin: Map<string, FreedataValueVO>): Map<string, FreedataValueVO> {
    let result: Map<string, FreedataValueVO> = new Map();
    [...origin.values() || []].forEach(fdv => {
      if(this.doUserFilterOnFDV(fdv)) {
        result.set(fdv.code, fdv);
      }
    });
    return result;
  }

  /**
   * filtre sur le FD depuis un filtre global
   * @param item 
   * @returns true si pas filtré
   */
  public doGlobalFilterOnFDV(item: FreedataValueVO): boolean {
    let globalKeys: Map<string, Set<string>> = this.model.widgetEngine.globalFilterKeys;

    let imDead: boolean = false;
    // prendre tous les args de type obj
    [...globalKeys.keys()].forEach(fk => {
      let smallKey: string = fk.split(WizConstants.CONTEXT_SEPARATOR)[0];
      if(!imDead && !!item.argsObjVO[smallKey]) { // une valeur pour cette clé
        let userResSet: Set<string> = globalKeys.get(fk);
        try {
          let itemPart: string = item.argsObjVO[smallKey].split(WizConstants.CONTEXT_SEPARATOR)[1];
          if(!userResSet.has(itemPart)) {
            imDead = true;
          } 
        }catch(e:any) {

        }
        
      }
    });
  
     return !imDead;
  }

  /**
   * contrôle la validité d'un élément pour un filtre de type FREEDATA pour les restrictions User / profiles
   * les filtres sont portés par les users(onglet user.role) ou par les profils
   * sous la forme {"HP#2":["10","11"]}
   * @param item FreedataValueVO
   */
  public  doUserFilterOnFDV(item: FreedataValueVO): boolean {
    let result: boolean = true;
    if(!(this.userGlobalFilter.size > 0)) { // pas de filtre, sortie directe
      return true;
    }

    // gérer les # niveau sur le même FD
    let fullKey: string = [item.freeDataCode, item.level].join(WizConstants.CONTEXT_SEPARATOR);
    if(!!this.userGlobalFilter.has(fullKey)) { // il existe une restriction sur cette clé
      result = !!this.userGlobalFilter.get(fullKey)?.has(item.code);
    }

    // fin du contrôle par utilisateur, première chance de rater
    if(!result) { // le filtre global me laisse passer
      // item.isRendered = false;
      return false; // filtré par le filtre global
    }  

    // tester la propriété sur le FD.arg
    try {
      [...this.userGlobalFilter.keys()].forEach(fk => {
        
        // console.log('userGlobalFilter.keys', fk);
        if(!!result) {
          let fkParts: string[]= fk.split(WizConstants.CONTEXT_SEPARATOR);
          let arg: FreedataArgsVO = item.getParentFDVO()?.getArgsVOMap()?.get(fkParts[0]);
          if(arg && arg.datas === fk) {
            // console.log('arg on FDV', arg);
            let fdvVal: string = item.argsObjVO[fkParts[0]]?.split(WizConstants.CONTEXT_SEPARATOR)[1] || null;
            if(!!fdvVal && !this.userGlobalFilter.get(fk)?.has(fdvVal) ) {
              result = false;
            }
          }
        }
      });
      
    } catch(e:any) {
      console.log('user filter on FDV', item.freeDataCode, item.code, e);
    }



    return result; // pas de restriction sur la clé demandée
  }

  /**
   * contrôle la validité d'un élément pour un filtre de type FREEDATA pour les restrictions depuis un autre FDV
   * les filtres sont portés par le restrict du FDV
   * sous la forme {"HP#2":["10","11"]}
   * fonctionne toujours sur les keys
   * fonctionne sur les filterKeys SEULEMENT si PAS en mode pivot
   * @param widget 
   * @param line 
   * @param item FreedataValueVO
   * @param fakeValues lors d'un appel depuis un formulaire (create / update)
   * @returns 
   */
  public  doUserFDVFilterOnFDV(widget: IWidget, line: WidgetLine, item: FreedataValueVO, fakeValues?: Map<string, string>): boolean {
    
    if(!item.restrict) { // pas de restriction sur l'élément de codif
      return true;
    }
    
    let restrictCollObj: any; // l'objet restriction (possible collection)
    let restrictFD: string; // le FD cible pour cette restriction
    let restrictSet: Set<string>; // les valeurs acceptables pour cette restriction
    
    let fkd: FeiKeyDef; // le FKD dans le widget (le fei), sinon c'est sans objet
    let lineFDV: FreedataValueVO;
    let lineFDVCode: string;
    let lineShortcode: string;

    restrictCollObj = JSON.parse(item.restrict); // construction de l'objet
    
    let restrictItem: any[] = []; // gestion en collection par OU

    
    if(restrictCollObj.OR) { // ici gérer du OU en cas de collection préfixée par OR
      [...restrictCollObj.OR].forEach(cond => {
        restrictItem.push(cond);
      });
    } else {
      restrictItem.push(restrictCollObj);
    }

    let imOut: boolean = true; // résultat pour chaque élément, si un seul FALSE, c'est FALSE
    let conditionOut: number = 0; // pour une condition complète, c'est un ET, il faut TOUT
    restrictItem.forEach(cond => {
      
      if(imOut) { //  pour l'instant, je suis exclus...
        conditionOut = 0; // il faut TOUT, donc conditionOut === Object.keys(cond).length

        // pour chaque élément de la condition (AND)
        Object.keys(cond).forEach(rkey => { // rkey c'est code#level
    
          restrictFD = rkey.split(WizConstants.CONTEXT_SEPARATOR)[0]; // le code du FD
          restrictSet = new Set(cond[rkey]); // les valeurs possibles
    
          let fkd = null;
          try {
            fkd = widget.fei.keyMap.get(rkey); // on prend la FDK sur le FEI
          }catch( e:any) {
            fkd = (widget as any).fakeFei.keyMap.get(rkey); // on prend la FDK sur le FEI
          }
          // if(widget instanceof FreedataFormWidget) {
            
          // } else {
            
          // }
          
    
          if(fkd) { // c'est un filtre qui fait partie du fei
            // on prend la valeur pour ce FD pour cette ligne
            if(widget.pivotMode && fkd.isFilterKey) {
              // on fait rien, pas de gestion de filtre sur une filterKey en pivot
            } else { // soit KEY soit filterKey en mode GRID
              // on prend la valeur pour le Fd sur la baseline
              
              if(!!fakeValues) {
                // console.log('call from form', fakeValues);
                lineFDVCode = fakeValues.get(rkey);
              } else {
                lineFDVCode = BaselineEngine.getRawKey(widget.fei, line, rkey);
              }
  
              lineFDV = this.model.freedataEngine.getFreedataValue(restrictFD, lineFDVCode);
              lineShortcode = lineFDV?.shortCode || null;
              if(restrictSet.has(lineShortcode)) { // j'ai une valeur
                conditionOut++; 
              }
              // console.log('fdv restrict', item.code, item.restrict, lineFDVCode, lineShortcode, imOut);
            }
            
          }
          
        });

        if(conditionOut === Object.keys(cond).length) { // tout à TRUE
          imOut = false;
        }
      }

    });

    return !imOut; // pas de restriction sur la clé demandée
  }


  /**
   * contrôle la validité d'un élément pour un filtre de type BASELINE pour les restrictions User / profiles
   * les filtres sont portés par les users(onglet user.role) ou par les profils
   * sous la forme {"HP#2":["10","11"]}
   * @param fei porteur de la ligne
   * @param item widgetLine
   */
  public doUserFilter(fei: FeiVO, item: WidgetLine): boolean {
    let result: boolean = true;

    if(!(this.userGlobalFilter.size > 0)) { // pas de filtre, sortie directe
      return true;
    }

    let fkd: FeiKeyDef;  
    let filterKeys: Set<string>;
    // console.log('filtre utilisateur', WidgetEngine.userGlobalFilter);
    [...this.userGlobalFilter.keys()].forEach(fdKey => {
      fkd = fei.keyMap?.get(fdKey);
      filterKeys = this.userGlobalFilter.get(fdKey);

      // TODO TODO prise en compte d'un filtre sur les autres niveau du FD
      if(!fei?.keyMap?.has(fdKey)) { // je ne filtre que sur ce que je possède
        return true;
      }

      // if(filterKeys.has(ViewData.wildcardDomain)) { // j'ai un filtre user, mais c'est *
      //   return true;
      // }

      // alimentation des valeurs brutes
      let itemValues: Set<string> = null;
      let res = BaselineEngine.getRawKeyOrValue(fei, item, fkd.fullCode);
      if(res?.length > 0) {
        itemValues = new Set([res]);
      }

      if(itemValues) {
        let intersection: string[] = []; // détection d'intersection (result OK)
        intersection = [...itemValues].filter((element) => filterKeys.has((element)));
  
        if (!intersection || intersection.length <= 0) {
          result = false;
        }
      }
      
    });
    return result;
  }

  /**
   * contrôle la validité d'un élément pour un filtre de type BASELINE
   * @param item la WidgetLine
   * @param filter IWidgetFilter
   * @param widget IWidget pour prise du mode pivot (ou pas)
   * @returns true si ça passe
   */
  public doFilter(item: WidgetLine, filter: IWidgetFilter, widget: IWidget): boolean {
    let result: boolean = true;

    // alimentation des valeurs brutes
    let itemValues: Set<string> = null;
    
    if(!!filter.regex && (filter.fkd.isFreedata || filter.fkd.isChrono)) { // recherche par regex, il faut les vraies valeurs, pas les codes sur les FD et les chronos
      if(widget.pivotMode) { // mode pivot
        itemValues = BaselineEngine.getPivotRawKeysOrValues(filter.widget.fei, item, filter.fkd.fullCode, filter.wcio.fdvf || WizConstants.FIELD_LABEL);
      }
      else { // mode simple
        let res = BaselineEngine.getLabel(filter.widget.fei, item, filter.fkd.fullCode, filter.wcio.fdvf || WizConstants.FIELD_LABEL);
        if(res?.length > 0) {
          itemValues = new Set([res]);
        }
      }
    } else { // sinon, juste les codes ou les mesures brutes
      if(widget.pivotMode) { // mode pivot
        
        // TODO gérer filtre générique
        // TODO alimenter keystr sur les widgetlines

        if(filter.fkd.isMeasure && item.isSubTotalLine) {
          let aggMethod: string = this.model.dataEngine.pkdDefaultAggregateFunction(filter.fkd.datakind);

          if(filter.fkd.measure.defaultAgg) {
            aggMethod = filter.fkd.measure.defaultAgg;
          }
          if(item.subTotalLevel > 0) {
            itemValues = new Set([...this.model.aggregateEngine.call(aggMethod, filter.widget.fei, widget.getSubTotalPool(item), filter.fkd)]); 
          } else {
            itemValues = new Set([...this.model.aggregateEngine.call(aggMethod, filter.widget.fei, [...item.ch?.values()], filter.fkd)]); 
          }  
          // console.log('ici',item.isSubTotalLine, item.subTotalLevel, itemValues);

        } else {
          itemValues = BaselineEngine.getPivotRawKeysOrValues(filter.widget.fei, item, filter.fkd.fullCode, null);
        }
        
      }
      else { // mode simple
        
        // filtre générique
        let res;
        if(filter.wcio.cod === ViewData.FILTER_GENERIC) {
          res = item.byWidgetStringMap?.get(widget.uid); // TODO prise des keysStr des baselines de la widgetLine
        } else if(filter.wcio.cod === ViewData.FILTER_ME) {
          res = item.bl?.createBy; // on prend le createBy sur la BL
        } else {
          res = BaselineEngine.getRawKeyOrValue(filter.widget.fei, item, filter.fkd.fullCode);
        }
        if(res?.length > 0) {
          itemValues = new Set([res]);
        }
      }

      if(filter.fkd?.datakind === FIELD_KIND.LIST && itemValues?.size > 0) { // patch filtre sur mesure de type liste
        let realValues: Set<string> = new Set();
        [...itemValues.values()].forEach(rawList => {
          try {
            let rawobj = JSON.parse(rawList);
            Object.keys(rawobj).forEach((s: string) => {
              if(s) {
                realValues.add(s);
              }
            });
          } catch(e: any) {
            console.log('invalid list value: ', rawList);
          }
        });
        itemValues = realValues;
      }
    }
    // console.log('filter', item.key, filter.fkd.fullCode, filter.wcio.fdvf, itemValues);
    if(!itemValues || itemValues.size === 0) { // pas de valeur
      if(filter.comparator === COMPARATOR.EMPTY || filter.comparator === COMPARATOR.USER || filter.comparator === COMPARATOR.USER_OR_NULL) {
        return true; // j'suis vide et on cherche les vides, c'est OK
      }
      return false; // sinon, c'est raté
    }

    let intersection: string[] = []; // détection d'intersection (result OK)

    if(filter.regex) {
      // les valeurs de mesure en mode pivot sont déjà aggrégées
      let uniqueVal: string = [...itemValues][0];
      
 
     // console.log('applyExp', pfeo.rawVal, comp.code, partOne, partTwo );
     switch(filter.comparator) {
      case COMPARATOR.INF:
        // comparer les valeurs n'a du sens que si cette valeur n'est pas vide. Sinon, on va comparer avec 0 lorsque chaine vide ('')
        if (Number(uniqueVal) < Number(filter.regexOne)) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.INFEQUAL:
        // comparer les valeurs n'a du sens que si cette valeur n'est pas vide. Sinon, on va comparer avec 0 lorsque chaine vide ('')
        if (Number(uniqueVal) <= Number(filter.regexOne)) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.EQUAL: // TODO texte, recherche sur la valeur du fdvf
        if (uniqueVal === filter.regexOne) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.NOTEQUAL: // TODO texte, recherche sur la valeur du fdvf
        if (uniqueVal !== filter.regexOne) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.SUP:
        // comparer les valeurs n'a du sens que si cette valeur n'est pas vide. Sinon, on va comparer avec 0 lorsque chaine vide ('')
        if (Number(uniqueVal) > Number(filter.regexOne)) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.SUPEQUAL:
        // comparer les valeurs n'a du sens que si cette valeur n'est pas vide. Sinon, on va comparer avec 0 lorsque chaine vide ('')
        if (Number(uniqueVal) >= Number(filter.regexOne)) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.BET:
        // comparer les valeurs n'a du sens que si cette valeur n'est pas vide. Sinon, on va comparer avec 0 lorsque chaine vide ('')
        if (Number(uniqueVal) >= Number(filter.regexOne) && Number(uniqueVal) <= Number(filter.regexTwo)) {
          intersection.push(uniqueVal);
        }
        break;
      // case COMPARATOR.EMPTY:
      //   if (!pfeo.sortKey) {
      //     goodItems.push(pfeo);
      //   }
      //   break;
      case COMPARATOR.NOTEMPTY:
        if (uniqueVal?.length > 0) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.STARTWITH: // TODO texte, recherche sur la valeur du fdvf
        for (var i = 0, len = itemValues.size; i < len; i++) {
          uniqueVal = [...itemValues][i];
          if (uniqueVal?.toUpperCase().startsWith(filter.regexOne.toUpperCase())) {
            intersection.push(uniqueVal);
            break;
          }
        }
        break;
      case COMPARATOR.CONTAINS: // TODO texte, recherche sur la valeur du fdvf
        for (var i = 0, len = itemValues.size; i < len; i++) {
          uniqueVal = [...itemValues][i];
          if (uniqueVal?.toUpperCase().indexOf(filter.regexOne.toUpperCase()) > -1) {
            intersection.push(uniqueVal);
            break;
          }
        }
        break;
      case COMPARATOR.USER: // filtre sur un param du user
      case COMPARATOR.USER_OR_NULL: // filtre sur un param du user    
        if(this.userGlobalFilter.has(filter.fkd?.fullCode)) {  
        // if(this.userGlobalFilter.has(filter.regexOne)) {
            for (var i = 0, len = itemValues.size; i < len; i++) {
              uniqueVal = [...itemValues][i];
              // console.log('uniqueVal', uniqueVal);
              if (this.userGlobalFilter.get(filter.fkd?.fullCode).has(uniqueVal)) {
                intersection.push(uniqueVal);
                break;
              }
            }
        } else if(filter.comparator === COMPARATOR.USER_OR_NULL) {
          intersection.push("no restrict for user");
        }
        break;
    }

    } else if(filter.useSubs || filter.useNonUnique) { // sous-champ dans un FD
      intersection = [...itemValues].filter((element) => filter.realValues.has((element)));
    } else { // filtre classique
      
      // filtre générique
      if(filter.wcio.cod === ViewData.FILTER_GENERIC) {
        let findOne: boolean = false;
        if(itemValues?.size > 0) {
          [...itemValues.values()].forEach(s => {
            if(!findOne && !!s) {
              findOne = [...filter.values].every(v => s.includes(v.toUpperCase()));
            }
            //console.log('findOne', findOne, s, filter.values);
          });
        }
        if(findOne) {
          intersection.push('gotGeneric');
        }
      } else if(filter.wcio.cod === ViewData.FILTER_ME) {
        if(item.bl?.createBy === this.model.connectedUser.mail) {
          intersection.push('gotMe');
        }
      } else {
        intersection = [...itemValues].filter((element) => filter.values.has((element)));
      }


      //intersection = [...itemValues].filter((element) => filter.values.has((element)));
    }

    if (!intersection || intersection.length <= 0) {
      result = false;
    }

    return result;
  }


   /* ##############################################################################
                construction des aggregats
    ############################################################################### */ 

  /**
   * constructeur d'une clé d'unicité pour une WidgetLine en mode pivot
   * @param widget 
   * @param line 
   * @param level pour construction gigogne
   * @returns la clé unique pour cette WL
   */
  public generateAggregateLineKey(widget: IWidget, line: WidgetLine, level: number = 0): string {
    let fei: FeiVO = widget.fei as FeiVO; // le fei
    let context: WidgetConfigurationObj = widget.context; // le contexte
    
    let arrKey: string[] = []; // pour garder l'ordre
    
    let pool: WidgetConfigurationItemObj[] = null;

    if(context.revert) { // en revert, il faut prendre les valeurs en colonnes
      pool = context.c;
    } else {
      pool = context.r;
    }

    if(level > 0) { // pas de boucle inutile en cas de gigogne
      pool = pool.slice(0, level);
    }

    pool.forEach((wcio: WidgetConfigurationItemObj) => {
      let fkd: FeiKeyDef = fei.keyMap.get(wcio.cod);
      let val: string;
      if(fkd.isMeasure) {
        val = BaselineEngine.getValue(fei, line, line.cells.get(wcio.cod));
      } else if(fkd.isScen) {
        val = line.scen;
      } else {
        val = BaselineEngine.getRawKey(fei, line, wcio.cod);
      }
      arrKey.push(val);
    });
    
    return arrKey.join(WizConstants.KEY_SEPARATOR);
  }


  /* ##############################################################################
          Formulaires, construction des prototypes
     ############################################################################## */

  /**
   * sur Add, creation d'une WidgetLine from scratch
   * prise en compte d'un master pour alimenter ce qu'on peut (après, pas ici)
   * @returns un fake
   */
  public buildFakeWidgetLine(fei: FeiVO, callback: Function): void {

    let bl: Baseline = new Baseline();
    bl.level = fei.visionStepLevel;
    bl.scen = WizConstants.SCEN_FAKE_KEY_CODE;
    bl.trios = {};
    bl.splittedKey =  [];
    bl.values = {};
  
    let fkdSeq: FeiKeyDef = null;


    fei.visionKeys.forEach((fkd: FeiKeyDef) => {
      bl.trios[fkd.fullCode] = WizConstants.wildcardDomain;
      bl.splittedKey.push(WizConstants.wildcardDomain);
      if(fkd.isSequence) { // gestion des séquences, prise du next
        fkdSeq = fkd;
      } 
    });
    bl.key = bl.splittedKey.join(WizConstants.KEY_SEPARATOR);

    let widgetLine: WidgetLine = {};
    widgetLine.cells = new Map();
    widgetLine.bl = bl;

    if(!!fkdSeq) {
      new FreedataSeqCmd(this.model).getSequenceForBaseline(fei, fkdSeq, widgetLine, this.askForAddAfterSequence.bind(this), callback).execute();
    } else {
      callback(widgetLine);
    }
  }

  private askForAddAfterSequence(cmd: FreedataSeqCmd): void {
    cmd.wl.bl.splittedKey = [];
    cmd.fei.visionKeys.forEach((fkd: FeiKeyDef) => {
      if(fkd === cmd.fkd) { // gestion des séquences, prise du next
        cmd.wl.bl.trios[fkd.fullCode] = cmd.nextID.toString();
        cmd.wl.bl.splittedKey.push(cmd.nextID.toString());
      } else {
        cmd.wl.bl.trios[fkd.fullCode] = WizConstants.wildcardDomain;
        cmd.wl.bl.splittedKey.push(WizConstants.wildcardDomain); 
      }
    });
    cmd.viewCallback(cmd.wl);

  }

  /**
   * depuis le formulaire, création d'une capsule de WidgetLine pour génération de l'updateEntry
   * sur création de Baseline
   * @param fei 
   * @param bl 
   * @returns 
   */
  public buildWidgetLinePrototype(fei: FeiVO, bl: Baseline): WidgetLine {
    let wl: WidgetLine = {
      key: bl.key, 
      uk: [fei.scenario, bl.key].join(WizConstants.KEY_SEPARATOR),
      binKey: null,
      level: bl.level,
      scen: fei.scenario,
      bl,
      cells: new Map()
    }
    return wl;
  }

  /**
   * depuis les formulaires, création d'une vrai baseline depuis le prototype (la keyMap)
   * @param fei le vrai
   * @param keyPartMap <code FKD = value>... ou pas
   * @returns la baseline
   */
  public buildBaselineFromPrototype(fei: FeiVO, keyPartMap: Map<string, string>): Baseline {
    let realBL: Baseline = new Baseline();
    realBL.domain = fei.vision.domain;
    realBL.businessUnitCode = fei.vision.businessUnitCode;
    realBL.v = fei.visionCode;
    realBL.vs = fei.visionStep.code;
    realBL.scen = fei.scenario;
    realBL.level = fei.visionStepLevel;
    realBL.operation = EM_ACTION.CREATE;
    realBL.values = {};
    
    let splitted: string[] = []; // construction des clés de vision
    let filter: any = {};
    fei.visionKeys.forEach((fkd: FeiKeyDef) => {
      // si c'est une séquence, on l'alimente
      let part: string = keyPartMap.get(fkd.fullCode);
      if(fkd.isSequence) {
        // console.log('feedSequence', part);
        if(!part) {
          // TODO TODO passer sur l'appel getSequence
          // comme new FreedataSeqCmd(this.model).getSequence(newFdv, this.askForAddAfterSequence.bind(this)).execute();
          part = this.model.freedataEngine.getNextSequence(fei, fkd);
        } else {
          // console.log('feedSequence exist', part);
        }
      }
      splitted.push(part);
    });
    realBL.key = splitted.join(WizConstants.KEY_SEPARATOR); // alimentation de la clé

    // parentKey si stepLevel > 1
    if(fei.visionStepLevel > 1) {
      let nbPartForParent = fei.vision.keySizeByLevel.get(fei.visionStepLevel - 1);
      realBL.pkey = splitted.slice(0, nbPartForParent).join(WizConstants.KEY_SEPARATOR); // alimentation de la clé parente
    }
    
    fei.filterKeys.forEach((fkd: FeiKeyDef) => {
      if(!!keyPartMap.get(fkd.fullCode)) { // une filter key
        filter[fkd.fullCode] = keyPartMap.get(fkd.fullCode);
      }
    });
    realBL.fkeyjson = filter;

    fei.keys.forEach((fkd: FeiKeyDef) => {
      if(fkd.isMeasure && fkd.editable) {
        if(!!keyPartMap.get(fkd.fullCode)) { //  une valeur pour une mesure éditable

          let val: string = keyPartMap.get(fkd.fullCode);
          if(fkd.measure.upper && val?.length > 0) {
            val = val.toUpperCase();
          }

          BaselineEngine.baselineSetValue(realBL, fkd.fullCode, val);
        }
      }
    });
    return realBL;
  }

    /**
   * depuis les formulaires, génération des updateEntry pour la  baseline depuis le prototype (la keyMap)
   * @param fei le vrai
   * @param deltaMap <code FKD = value>... ou pas
   * @param forced champs pour lesquels on force la modif (messages)
   * @returns le pack d'UpdateEntry pour envoi au service de commit
   */
  public  updateBaselineFromPrototype(fei: FeiVO, widgetLine: WidgetLine, deltaMap: Map<string, string>, forced: Map<string, string> = null): UpdateEntry[] {
    
    let updates: UpdateEntry[] = [];
    
    let update: UpdateEntry;
    let fkd: FeiKeyDef;
    [...deltaMap.keys()].forEach((key: string) => {
      fkd = BaselineEngine.getKey(fei, key);
      if (!!fkd?.editable) {
        let newValue: string = deltaMap.get(key);
        let oldValue: string;
        if(fkd.isFilterKey) {
          oldValue = widgetLine.bl.fkeyjson ? widgetLine.bl.fkeyjson[key] : null;
        } else {
          oldValue = widgetLine.bl.values ? widgetLine.bl.values[key]?.valor : null;
        }
        if(!!forced?.has(key) || !this.model.dataEngine.equals(newValue, oldValue)) {
          update = this.model.dataEngine.generateUpdate(fei, widgetLine, fkd, newValue);
          updates.push(update);
        }

      }
    });
    return updates;
  }

  /* ##############################################################################
      construction d'un filtre symbolique pour un widget de type FREEDATA
     ############################################################################## */

  /**
   * construction d'un filtre pour les widgets
   * 
   * @param widget cible
   * @param wcio configuration du filtre
   * @returns IWidgetFilter
   */
  public  buildFreedataFilter(widget: IFreedataWidget, wcio: WidgetConfigurationItemObj): IWidgetFilter {
    let fkd: FeiKeyDef = widget.fkd;
    
    // le filtre en cours de construction
    let filter: IWidgetFilter = {widget, wcio, fkd, active: false, useSubs: false, useNonUnique: false};

    if (!!wcio.filtExp) { // filtre sur base d'expression
      // filter.active = true; // j'ai un filtre... même s'il fitre rien...
      filter.regex = wcio.filtExp;
      // filter.comparator = wcio.filtExp.split(ViewData.KEY_SEPARATOR)[0]; // on extrait le comparateur
    } else if(wcio.sel) { // ou filtre basé sur une sélection simple
      // filter.active = true; // j'ai un filtre...
      filter.values = new Set(wcio.sel.split(WizConstants.KEY_SEPARATOR));
    }

    // tag boolean
    if(wcio.fmt) {
      let parts: string[] = wcio.fmt.split(WizConstants.KEY_SEPARATOR);
      let format: FormatVO = Model.getInstance().formatEngine.getFormat(parts[0], parts[1]);
      if(format?.dataKind === FIELD_KIND.BOOLEAN) {
        // console.log("buildFreedataFilter boolan", filter);
        filter.onBoolean = true;
      }
    }

    // alimentation des données volatiles
    this.refreshFreedataFilter(filter);

    return filter;
  }

  /**
   * alimentation des données volatiles sur le filtre
   * - données regex
   * - collection véritable en cas de subFD
   * @param filter 
   */
  public refreshFreedataFilter(filter: IWidgetFilter): void {
    // console.log('refreshFilter', filter);
    if(!filter ||!filter.wcio) { // null si on force le refresh global sur GlobalFilter
      return;
    }

    // let fei: FeiVO = filter.widget.fei;
    let fkd: FeiKeyDef = filter.fkd;
    
    // on rince les données volatiles
    filter.active = false;
    filter.useSubs = false;
    filter.comparator = null;
    filter.regexOne = null;
    filter.regexTwo = null;
    filter.realValues = null;

    if(filter.wcio.cod === ViewData.FILTER_GENERIC) {
      filter.realValues = filter.values || new Set();
      filter.active = filter.realValues.size > 0;
    } else  if(filter.wcio.cod === ViewData.FILTER_ME) {
      filter.realValues = filter.values || new Set();
      filter.active = filter.realValues.size > 0;
    }
    else if (!!filter.regex) { // filtre sur base d'expression
      filter.active = true;
      let parts: any[] = filter.regex.split(WizConstants.KEY_SEPARATOR);
      filter.comparator = parts[0]; // on extrait le comparateur
      filter.regexOne = parts[1];
      filter.regexTwo = parts.length === 3 ? parts[2] : null;

      const fdParts: string[] = filter.wcio.cod.split(WizConstants.CONTEXT_SEPARATOR); // on prend le code du FD
      let fd: FreeDataVO = this.model.freedataEngine.getFreeData(fdParts[0]); // on le collecte
      let realField: string = this.fdvfSplitter(filter.wcio.fdvf)[0];  
      const arg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(fdParts[0], realField);
      // const arg: FreedataArgsVO = fd.getArgsVOMap().get(realField); // on regarde son args éventuel
      if (arg?.dataType === FIELD_KIND.DATE) { // c'est un subFD, on écrase le dataKind
        filter.onDate = true;
      } 

    } else if(filter.values?.size > 0) { // ou filtre basé sur une sélection simple
      filter.active = true;
      
      const fdParts: string[] = filter.wcio.cod.split(WizConstants.CONTEXT_SEPARATOR); // on prend le code du FD
      let fd: FreeDataVO = this.model.freedataEngine.getFreeData(fdParts[0]); // on le collecte
      let realField: string = this.fdvfSplitter(filter.wcio.fdvf)[0];  
      const arg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(fdParts[0], realField);
      // const arg: FreedataArgsVO = fd.getArgsVOMap().get(realField); // on regarde son args éventuel
      if (arg?.dataType === FIELD_KIND.DATE) { // c'est un subFD, on écrase le dataKind
        filter.onDate = true;
      } 

      // const arg: FreedataArgsVO = fd.getArgsVOMap().get(realField); // on regarde son args éventuel
      if (arg?.dataType === FIELD_KIND.OBJECT) { // c'est un subFD, on écrase le dataKind
        filter.useSubs = true;
      } 

      let uniqueFields: string[] = [WizConstants.FIELD_CODE, WizConstants.FIELD_SHORT_CODE, WizConstants.FIELD_LABEL];
      if(!!filter.wcio.fdvf && uniqueFields.indexOf(realField) === -1) {
        filter.useNonUnique = true;
      }

      let realValues: Set<string> = new Set();
      let argVal: string; // la valeur de mon FDV pour l'arg qui est stocké dans le filtre
      if(filter.useSubs) {
        // on a stocké des valeurs sur le sous-FD
        // il faut trouver les FDVs de mon niveau qui possèdent comme arg ce FDV
        // ou alimenter la keypair sur les widgetlines ??
        this.model.freedataEngine.getFreedataValuesByLevel(filter.wcio.cod).forEach((fdv: FreedataValueVO)=> {
          argVal = fdv.argsObjVO[arg.code];
          if(!!argVal && filter.values.has(argVal.split(WizConstants.CONTEXT_SEPARATOR)[1])) {
            realValues.add(fdv.code);
          }
        });
        filter.realValues = realValues;
      } else if (filter.useNonUnique) {
        this.model.freedataEngine.getFreedataValuesByLevel(filter.wcio.cod).forEach((fdv: FreedataValueVO)=> {
          argVal = fdv.argsObjVO[realField];
          if (!!filter.onDate && !!argVal) { // c'est un subFD, on écrase le dataKind
            argVal = argVal.substring(0,8);
          } 
              
          if(!!argVal && filter.values.has(argVal)) {
            realValues.add(fdv.code);
          }
        });
        filter.realValues = realValues;
      }
      
    }
  }

  /**
   * contrôle la validité d'un élément pour un filtre
   * @param item la WidgetLine
   * @param filter IWidgetFilter
   * @returns true si ça passe
   */
  public doFreedataFilter(item: FreedataValueVO, filter: IWidgetFilter, widgetUid: string): boolean {
    let result: boolean = true;

    // alimentation des valeurs brutes
    let itemValues: Set<string>;
    
    if(!!filter.regex && filter.fkd.isFreedata) { // recherche par regex, il faut les vraies valeurs, pas les codes sur les FD et les chronos

      let res = item.argsObjVO[filter.wcio.fdvf];
      // gestion spécifique pour les boolean
      
      if(res !== null && res !== undefined) {
        if(filter.onDate) { // passage des dates sur 8
            itemValues = new Set([res.substring(0,8)]); 
        } else {
          itemValues = new Set([res.toString()]);
        }
       
      }
      
    } else { // sinon, juste les codes ou les mesures brutes
      let res = null;
      if(filter.wcio.cod === ViewData.FILTER_ME) { // pour le filtre ME, on prend le createBy
        res = item.createBy;
      } else {
        res = item.code;
      }
      if(res?.length > 0) {
        itemValues = new Set([res]);
      }     
    }

    // gestion des boolean ternaires (ou pas)
    if(filter.onBoolean) {
      // console.log('filter.onBoolean')
      let filterVal: string = filter.values? [...filter.values.values()][0] : null;
      let itemVal: string = item.argsObjVO[filter.wcio.fdvf] || '0';
      if(filterVal !== itemVal) {
        return false;
      } else {
        return true;
      }
    } 

    if(!itemValues || itemValues.size === 0) { // pas de valeur
      if(filter.comparator === COMPARATOR.EMPTY || filter.comparator === COMPARATOR.USER || filter.comparator === COMPARATOR.USER_OR_NULL) {
        return true; // j'suis vide et on cherche les vides, c'est OK
      } else if(filter.comparator === COMPARATOR.NOTEQUAL) {// pour les booleans, permettre le notEquals
        // ne rien faire, on passe à la suite
      } else {
        return false; // sinon, c'est raté
      }
      
    }

    let intersection: string[] = []; // détection d'intersection (result OK)

    if(filter.regex) {
      // console.log('regex filter', filter, itemValues);

    // TODO TODO aggréger les valeurs en mode pivot
    let uniqueVal: string = itemValues?.size > 0 ? [...itemValues][0] : null;

     // console.log('applyExp', pfeo.rawVal, comp.code, partOne, partTwo );
     switch(filter.comparator) {
      case COMPARATOR.INF:
        // comparer les valeurs n'a du sens que si cette valeur n'est pas vide. Sinon, on va comparer avec 0 lorsque chaine vide ('')
        if (Number(uniqueVal) < Number(filter.regexOne)) {
          intersection.push(uniqueVal);
        }
        break;

      case COMPARATOR.INFEQUAL:
        // comparer les valeurs n'a du sens que si cette valeur n'est pas vide. Sinon, on va comparer avec 0 lorsque chaine vide ('')
        if (Number(uniqueVal) <= Number(filter.regexOne)) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.EQUAL: // TODO texte, recherche sur la valeur du fdvf
        if (uniqueVal === filter.regexOne) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.NOTEQUAL: // TODO texte, recherche sur la valeur du fdvf
        if (uniqueVal !== filter.regexOne) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.SUP:
        // comparer les valeurs n'a du sens que si cette valeur n'est pas vide. Sinon, on va comparer avec 0 lorsque chaine vide ('')
        if (Number(uniqueVal) > Number(filter.regexOne)) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.SUPEQUAL:
        // comparer les valeurs n'a du sens que si cette valeur n'est pas vide. Sinon, on va comparer avec 0 lorsque chaine vide ('')
        if (Number(uniqueVal) >= Number(filter.regexOne)) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.BET:
        // comparer les valeurs n'a du sens que si cette valeur n'est pas vide. Sinon, on va comparer avec 0 lorsque chaine vide ('')
        if (Number(uniqueVal) >= Number(filter.regexOne) && Number(uniqueVal) <= Number(filter.regexTwo)) {
          intersection.push(uniqueVal);
        }
        break;
      // case COMPARATOR.EMPTY:
      //   if (!pfeo.sortKey) {
      //     goodItems.push(pfeo);
      //   }
      //   break;
      case COMPARATOR.NOTEMPTY:
        if (uniqueVal?.length > 0) {
          intersection.push(uniqueVal);
        }
        break;
      case COMPARATOR.STARTWITH: // TODO texte, recherche sur la valeur du fdvf
        if(itemValues?.size > 0) {
          for (var i = 0, len = itemValues.size; i < len; i++) {
            uniqueVal = [...itemValues][i];
            if (uniqueVal.toUpperCase().startsWith(filter.regexOne.toUpperCase())) {
              intersection.push(uniqueVal);
              break;
            }
          }
        }
        break;
      case COMPARATOR.CONTAINS: // TODO texte, recherche sur la valeur du fdvf
        if(itemValues?.size > 0) {
          for (var i = 0, len = itemValues.size; i < len; i++) {
            uniqueVal = [...itemValues][i];
            if (uniqueVal.toUpperCase().indexOf(filter.regexOne.toUpperCase()) > -1) {
              intersection.push(uniqueVal);
              break;
            }
          }
        }

        break;
      case COMPARATOR.USER: // filtre sur un param du user
      case COMPARATOR.USER_OR_NULL: // filtre sur un param du user    
        if(this.userGlobalFilter.has(filter.wcio?.fdvf)) {
          for (var i = 0, len = itemValues?.size; i < len; i++) {
            uniqueVal = [...itemValues][i];
            // console.log('uniqueVal', uniqueVal);
            if (this.userGlobalFilter.get(filter.wcio.fdvf).has(uniqueVal)) {
              intersection.push(uniqueVal);
              break;
            }
          }
        } else if(filter.comparator === COMPARATOR.USER_OR_NULL) {
           intersection.push("no restrict for user");
        }
        break;
    }

    } else if(filter.useSubs || filter.useNonUnique) { // sous-champ dans un FD
      intersection = [...itemValues].filter((element) => filter.realValues.has((element)));
    } else { // filtre classique
      // filtre générique
      if(filter.wcio.cod === ViewData.FILTER_GENERIC) {
        const allFound = [...filter.values].every(v => item.byWidgetStringMap.get(widgetUid).includes(v.toUpperCase()));
        if(allFound) {
          intersection.push('gotYou');
        }
      } else if(filter.wcio.cod === ViewData.FILTER_ME) {
        intersection = [...itemValues].filter((element) => element === this.model.currentUser.mail);
        // console.log("doFilter", itemValues, this.model.currentUser.mail, intersection);
      } else {
        intersection = [...itemValues].filter((element) => filter.values.has((element)));
      }
      
    }

    if (!intersection || intersection.length <= 0) {
      result = false;
    }

    return result;
  }

  /* #############################################################
         calculs sur FakeFEI (control, restrict, styles, forms)
     ############################################################# */
  
    public chartComputeStyle(fei: FeiVO, style: StyleVO, wl: WidgetLine, value: any): any {
    let result: any = this._model.styleEngine.stringToCss(StyleEngine.NO_CSS); // le format css à retourner
    let sl: StyleLineVO; // la ligne de style
    let formula: string; // la formule générée

    for (let i = 0; i < style.linesVO.length; i++) { // pour chaque condition du style
        sl = style.linesVO[i];
        if (sl.comparator === 'Exp') { // expression complète, sans comparateur
            formula = '=' + sl.formula;
        } else {
            let cleanParam = value;
            if (isNaN(cleanParam)) { // TODO prise en compte des formats de mesures
                // pas un number, on l'entoure par ""
                cleanParam = '"' + cleanParam + '"';
            }
            formula = '=IF(' + cleanParam + sl.comparator + '(' + sl.formula + ');1;0)';
        }

        // création du faux mm
        const mm: MeasMode = MeasureCoreEngine.LightFakeMeasureMode(
            fei,
            WizConstants.FAKE_STYLE,
            WizConstants.MEASURE_MODE_SUBMIT, 
            formula); // construction d'une fausse mesure, pour calcul

        const cr: ComputeResult = FormulaCoreEngine.computeMmiDependencies(mm.mmi, wl, fei, true);
        if (cr.valor === '1') {
            result = sl.cssAsObject;
            break;
        }
    }
    return result;

  }
        
  /**
   * génération d'un style pour les timelines
   * @param fei 
   * @param style 
   * @param wl 
   */
  public computeStyleForWidgetLine(fei: FeiVO, style: StyleVO, wl: WidgetLine): any {
    let result: any = null; // le format css à retourner
    let sl: StyleLineVO; // la ligne de style
    let formula: string; // la formule générée

    for (let i = 0; i < style.linesVO.length; i++) { // pour chaque condition du style
        sl = style.linesVO[i];
        if (sl.comparator === 'Exp') { // expression complète, sans comparateur
            formula = '=' + sl.formula;
        } else {
           return null;
        }

        // création du faux mm
        const mm: MeasMode = MeasureCoreEngine.LightFakeMeasureMode(
            fei,
            WizConstants.FAKE_STYLE,
            WizConstants.MEASURE_MODE_SUBMIT, 
            formula); // construction d'une fausse mesure, pour calcul

        const cr: ComputeResult = FormulaCoreEngine.computeMmiDependencies(mm.mmi, wl, fei, true);
        if (cr.valor === '1') {
            result = sl.cssAsObject;
            break;
        }
    }
    return result;

  }

  /**
   * calcul successif des conditions de style, sortie à la première qui retourne true (1)
   * @param fei porteur
   * @param style le style et toutes ses conditions
   * @param params la configuration de la cellule cible
   * @param standard css vide / ou css de la cellule
   * @param revertLine en cas de mode revert, la vrai ligne
   * @returns le css à appliquer
   */
  public computeStyle(fei: FeiVO, style: StyleVO, params: any, standard: any, revertLine?: WidgetLine): any {
      
    // TODO prise en compte des formats textes
    // TODO comparateur textuel
    let result: any = standard; // le format css à retourner
    let wl: WidgetLine = null;
    if(!!revertLine) {
      wl = revertLine;
    } else {
      wl = params.data; // le contenu de la cellule cible
    }

    // gestion des rendus sur les pivots avec colonnes
    const widget: IWidget = (params.colDef as WizColDef).widget
    const linePack: WidgetLine[] = widget.pivotMode ? widget.getPool(wl, params.column) : null;
    if(linePack?.length > 0) {
        wl = linePack[0];
    }


    let sl: StyleLineVO; // la ligne de style
    let formula: string; // la formule générée

    for (let i = 0; i < style.linesVO.length; i++) { // pour chaque condition du style
        sl = style.linesVO[i];
        if (sl.comparator === 'Exp') { // expression complète, sans comparateur
            formula = '=' + sl.formula;
        } else {
            let cleanParam = params.value;
            if (isNaN(cleanParam)) { // TODO prise en compte des formats de mesures
                // pas un number, on l'entoure par ""
                cleanParam = '"' + cleanParam + '"';
            }
            formula = '=IF(' + cleanParam + sl.comparator + '(' + sl.formula + ');1;0)';
        }

        // création du faux mm
        const mm: MeasMode = MeasureCoreEngine.LightFakeMeasureMode(
            fei,
            WizConstants.FAKE_STYLE,
            WizConstants.MEASURE_MODE_SUBMIT, 
            formula); // construction d'une fausse mesure, pour calcul

        const cr: ComputeResult = FormulaCoreEngine.computeMmiDependencies(mm.mmi, wl, fei, true);
        if (cr.valor === '1') {
            result = sl.cssAsObject;
            break;
        }
    }
    return result;
  }   



  /**
   * contrôle avant édition
   * le contrôle ne DOIT PAS présenter le IF, on va l'ajouter. On attend un truc du style : LMA_ED3#I=1
   * @param fei porteur
   * @param targetMeasure mesure cible
   * @param wls pool de widgetLine
   * @param fakeMode pour appel depuis la génération des styles / des forms pour éviter la persistence des dépendances dans CellMatrix
   * @param fakeValues injection de valeurs fictive pour pré-calcul field(mesure éditable) = value
   * @returns true si éditable
   */
  public computeEditRestrict(fei: FeiVO, targetMeasure: Measure, wls: WidgetLine[], fakeMode: boolean = true, fakeValues?: Map<string, string>): boolean {
      let result: boolean = true; // par défaut, aucun contrôle

      const mm: MeasMode = MeasureCoreEngine.LightFakeMeasureMode(
          fei,
          [WizConstants.FAKE_EDIT_RESTRICT, targetMeasure.shortCode].join(WizConstants.CODE_LEVEL_SEPARATOR),
          WizConstants.MEASURE_MODE_SUBMIT,
          '=IF((' + targetMeasure.editRestrict + ');1;0)');

      let toChecks: WidgetLine[] = [...wls];
      let wl: WidgetLine = toChecks.pop();

      while (!!wl && result) {
          const cr: ComputeResult = FormulaCoreEngine.computeMmiDependencies(mm.mmi, wl, fei, true, fakeValues);
          if (cr.valor !== '1') {
              result = false;
          }
          wl = toChecks.pop(); // on prend la prochaine
      }
      return result;
  }

  /**
   * exécute un pack de contrôle, renvoie les erreur sous forme code de la mesure = errorStr
   * @param fei porteur
   * @param measures MeasureVO[] fonctions de contrôle
   * @param pl widgetLines cibles
   * @param mode EDIT_RESTRICT ou VALUE_CONTROL
   * @returns la map d'erreurs, par code de mesure
   */
  public computeIntegrity(fei: FeiVO, measures: Measure[], lines: WidgetLine[], mode: string, updates: UpdateEntry[] = null): Map<Measure, string> {
      
      const errorMap: Map<Measure, string> = new Map();
      const mmMap: Map<MeasMode, MeasureVO> = new Map(); // on va stocker les fakes mms et les lier à la mesure source

      // va basculer entre les formule de restriction ou les formules de contrôle de valeurs
      const targetcheck: string = mode ? mode: WizConstants.CHECK_MODE_CONTROL; //  === WizConstants.CHECK_MODE_RESTRICT ? WizConstants.CHECK_MODE_RESTRICT : WizConstants.CHECK_MODE_CONTROL;

      measures.forEach((sourceMeas: Measure) => { // création des mesures
       
          if (!!sourceMeas[targetcheck]) {
             
            let mm: MeasMode;
            if(targetcheck === WizConstants.CHECK_MODE_INTEGRITY) {

              mm = MeasureCoreEngine.LightFakeMeasureMode(
                fei,
                [WizConstants.FAKE_INTEGRITY, sourceMeas.shortCode].join(WizConstants.CODE_LEVEL_SEPARATOR),
                WizConstants.MEASURE_MODE_SUBMIT,
                sourceMeas[targetcheck]);

            } else {
              mm = MeasureCoreEngine.LightFakeMeasureMode(
                fei,
                [WizConstants.FAKE_INTEGRITY, sourceMeas.shortCode].join(WizConstants.CODE_LEVEL_SEPARATOR),
                WizConstants.MEASURE_MODE_SUBMIT,
                '=IF((' + sourceMeas[targetcheck] + ');1;0)');

            }

            mmMap.set(mm, new MeasureVO(sourceMeas)); // ajout à la map
          }
      });

      let bl: Baseline;
      let measKey: string;
      let cell: any; // AkmCell, y'a pas d'import depuis compute, et pas vraiment besoin...
      lines.forEach((wl: WidgetLine) => { // pour chaque WidgetLine
          bl = wl.bl; // la baseline
          
          if(mode === WizConstants.CHECK_MODE_CONTROL) { // mode contrôle, ajout des éventuels min & max
              measures.forEach((m: Measure) => {    
                  if(m.minValue !== null) {
                      // console.log('has min on meas', m.code, m.minValue, currentBaseline);
                      measKey = [m.shortCode, WizConstants.MEASURE_MODE_INTERACT].join(WizConstants.CONTEXT_SEPARATOR);
                      cell = fei.model.cellMatrixEngine.getCell(bl.level, bl.key, bl.scen, measKey);
                      if(m.dataKind === FIELD_KIND.STRING || m.dataKind === FIELD_KIND.COMMENT) {
                        if(cell?.valor?.length > 0  && cell.valor.length < Number(m.minValue)) { // taille min sur string
                          let mess: string = WizTranslationManager.getInstance().translateKey('validators.numberValidator.lowerThanMinError', [m.minValue]);
                          errorMap.set(m, mess);
                        }  
                      } else {
                        if(cell?.valor?.length > 0  && Number(cell.valor) < Number(m.minValue)) {
                          let mess: string = WizTranslationManager.getInstance().translateKey('validators.numberValidator.lowerThanMinError', [m.minValue]);
                          errorMap.set(m, mess);
                        }  
                      }
                      

                  }
                  if(m.maxValue !== null) {
                      // console.log('has min on meas', m.code, m.minValue, currentBaseline);
                      measKey = [m.shortCode, WizConstants.MEASURE_MODE_INTERACT].join(WizConstants.CONTEXT_SEPARATOR);
                      cell = fei.model.cellMatrixEngine.getCell(bl.level, bl.key, bl.scen, measKey);
                      if(m.dataKind === FIELD_KIND.STRING || m.dataKind === FIELD_KIND.COMMENT) {
                        if(cell?.valor?.length > Number(m.maxValue)) { // taille min sur string
                          let mess: string = WizTranslationManager.getInstance().translateKey('validators.numberValidator.greaterThanMaxError', [m.maxValue]);
                          errorMap.set(m, mess);
                        }  
                      } else {
                        if(cell?.valor?.length > 0  && Number(cell.valor) > Number(m.maxValue)) {
                          let mess: string = WizTranslationManager.getInstance().translateKey('validators.numberValidator.greaterThanMaxError', [m.maxValue]);
                          errorMap.set(m, mess);
                        }
                      }
                  }
              });
          }       

          // recherche de modifs sur les filterKey, pour contrôle correct des KeyVal
          let ctrlWidgetLine: WidgetLine = null;
          updates?.forEach((ue: UpdateEntry) => {
            if(ue.baselineOperation && ue.baseline.key === wl.bl.key) {
              if(!ctrlWidgetLine) {
                ctrlWidgetLine = cloneDeep(wl); // on perd l'instance
                // et on applique la modif
                BaselineEngine.baselineSetFilterKeyValue(ctrlWidgetLine.bl, ue.field, ue.newValue);
              }
            }
          });
          if(!ctrlWidgetLine) {
            ctrlWidgetLine = wl;
          }


          [...mmMap.keys()].forEach((mm: MeasMode) => {
              const cr: ComputeResult = FormulaCoreEngine.computeMmiDependencies(mm.mmi, ctrlWidgetLine, fei, true);
              if (cr.valor !== '1') {
                  if (mode === WizConstants.CHECK_MODE_RESTRICT) {
                      errorMap.set(mmMap.get(mm).source, mmMap.get(mm).measureEditRestrictMessage);
                  } else {
                      errorMap.set(mmMap.get(mm).source, mmMap.get(mm).measureControlMessage);
                  }
              }
          });
      });

      return errorMap;
  }

  /**
   * applique la valeur par défaut pour un field de FDV
   * @param fei cible (un fake)
   * @param wl: WidgetLine
   * @param fdCode#lvl code du freedata concerné
   * @returns la valeur par défaut
   */
  public computeDefaultValue(fei: FeiVO, wl: WidgetLine, fdCode: string): string {
    const fd: FreeDataVO = this.model.freedataEngine.getFreeData(fdCode.split(WizConstants.CONTEXT_SEPARATOR)[0]);
    if (!!fd?.defaultValue) { // en cas de valeur par défaut, on va la calculer
      const mm: MeasMode = MeasureCoreEngine.LightFakeMeasureMode(fei,
        [WizConstants.FAKE_DEFAULT_VALUE, fd.code].join(WizConstants.CODE_LEVEL_SEPARATOR),
        WizConstants.MEASURE_MODE_SUBMIT,
        '=' + fd.defaultValue);

      const cr: ComputeResult = FormulaCoreEngine.computeMmiDependencies(mm.mmi, wl, fei, true);
      return cr?.valor || null;
    }
    return null;
  }

  /**
   * applique les restrictions du FDV pour affichage dans les listes de choix des filterKeys
   * ATTENTION évols 2025 widgetGenerator & filtres avancés : le filtre peut être sous la forme {"HP#2":["10","11"]}
   * Dans ce cas, on bascule sur doUserFDVFilterOnFDV
   * @param widget (le form)
   * @param fei cible (un fake)
   * @param wl: WidgetLine
   * @param fdavo fdv
   * @param fakeMode (true)
   * @param fakeValues pour override sur le prototype
   * @returns true si l'élément EST FILTRé
   */
  public computeListRestrict(widget: IWidget, fei: FeiVO, wl: WidgetLine, fdavo: FreedataValueVO, fakeMode: boolean = false, fakeValues?: Map<string, string>): boolean {
    if (!!fdavo.restrict) { // en cas de validateur
      
      try {
        let restrictObj: any = JSON.parse(fdavo.restrict); // construction de l'objet JSON OK 
        return !this.doUserFDVFilterOnFDV(widget, wl, fdavo, fakeValues);
      } catch (e: any) {
        const mm: MeasMode = MeasureCoreEngine.LightFakeMeasureMode(fei,
          [WizConstants.FAKE_LIST_RESTRICT, fdavo.freeDataCode, fdavo.code].join(WizConstants.CODE_LEVEL_SEPARATOR),
          WizConstants.MEASURE_MODE_SUBMIT,
          '=IF(' + fdavo.restrict + ';1;0)');
  
  
        // if(mm.code === '@@FLIST_ENGAGE_Z06#S') {
        //   console.log('listRestrict', mm.code, mm.form);
        // }
        const cr: ComputeResult = FormulaCoreEngine.computeMmiDependencies(mm.mmi, wl, fei, true, fakeValues);
        // if(mm.code === '@@FLIST_ENGAGE_Z06#S') {
        //   console.log('listRestrict', mm.code, mm.form, cr.valor);
        // }  
  
        if (cr.valor === '1') {
          return false; // pas filtré
        } else { // filtré
          return true;
        }
      }
    }
    return false;
  }

  /** construction d'une entrée de groupe custom
   * @param widget source
   * @param wcio la conf
   */
  public generateGroupEntry(widget: IWidget, idx: number = 0, wcio?: WidgetConfigurationItemObj): PivotField {
    const cod: string = 'grp' + idx;
    const ord: number = idx;
    const conf: WidgetConfigurationItemObj = wcio ? wcio : this.newWcio(cod, ord);
    if(!wcio) {
      conf.lbl = cod;
    }

    // construction d'un fake de mesure pour alimenter le pivotField
    const fakeMeas: Measure = new Measure();
    fakeMeas.code = conf.cod.split(WizConstants.CONTEXT_SEPARATOR)[0];
    fakeMeas.shortCode = fakeMeas.code;
    fakeMeas.mode = WizConstants.MEASURE_MODE_INTERACT;
    // const fakeMeasVO: MeasureVO = new MeasureVO(fakeMeas);
    const pkd: FeiKeyDef = BaselineEngine.buildFeiKeyDef(widget.fei, KEY_KIND.MEASURE, fakeMeas);

    const res: PivotField = new PivotField(widget, conf, pkd, null);
    res.parentGroup = conf.pgrp;
    // console.log('generateGroupEntry',conf.cod, res.parentGroup );
    return res;
  }

  /**
   * mode compute ?
   * @param widget 
   * @returns true si oui
   */
  public widgetIsCompute(widget: IWidget): boolean {
    let result: boolean = widget.context?.cm === COMPUTE_MODE.COMPUTE;
    let realFEI: FeiVO;
    // LMA neutralisation pour forcer le mode compute
    // if(widget.fei) {
    //   realFEI = this.model.dataEngine.getFei(widget.fei.visionStepLevel, widget.fei.scenario) as FeiVO;
    //   if(realFEI?.computeMode === COMPUTE_MODE.LOCAL) {
    //    result = false;
    //   }
    // }
    // console.log('widgetIsCompute ', widget.fei?.uniqueName, widget.fei?.computeMode, realFEI?.computeMode, result);
    return result;
  }

  /**
   * page en cours ou 1
   * @param widget 
   * @returns 
   */
  public widgetCurrentPage(widget: IWidget): number {
    let current: number = widget.context?.cmp;
    return current || 1;
  }

  /**
   * taille de page pour un widget
   * @param widget 
   * @returns 
   */
  public widgetPageSize(widget: IWidget): number {
    let pageSize: number = widget.context?.cms || 100;
    return pageSize;
  }

  /** 
   * retourne le nombre de pages pour ce widget en cas de mode COMPUTE
   * @param widget source
   * @param wcio la conf
   */
  public widgetMaxPages(widget: IWidget): number {
    let maxPage: number = null;
    if(widget?.context?.cm === COMPUTE_MODE.COMPUTE) { //seulement pour compute
      try {
        maxPage = Math.ceil((widget.fei.totalSizes?.get(widget.uid) || 0) / this.widgetPageSize(widget));
      } catch(e: any) {
  
      };
    }
    return maxPage;
  }

  /**
   * calcul successif des conditions de style, sortie à la première qui retourne true (1)
   * @param fei porteur
   * @param style le style et toutes ses conditions
   * @param params la configuration de la cellule cible
   * @returns le css à appliquer
   */
  public computeConsoRowStyle(fei: FeiVO, style: StyleVO, params: any): any {
      
    let result: any = null; // le format css à retourner
    let wl: WidgetLine = params.data; // le contenu de la cellule cible
    
    let sl: StyleLineVO; // la ligne de style
    let formula: string; // la formule générée

    // il nous faut une ligne véritable
    let witness: WidgetLine = wl;
    let hasChild: boolean = wl.ch?.size > 0;
    while(hasChild) {
      witness = [...witness.ch.values()][0];
      hasChild = witness.ch?.size > 0;
    }

    // injection des fakes consolidés
    // let fakeValues: Map<string, string> = new Map();
    // [...wl.pivotValues?.values()].forEach(sub => {
    //   [...sub.keys()].forEach(k => {
    //     fakeValues.set(k, sub.get(k));
    //   });
    // });

    for (let i = 0; i < style.linesVO.length; i++) { // pour chaque condition du style
        sl = style.linesVO[i];
        formula = '=' + sl.formula;
        
        // création du faux mm
        const mm: MeasMode = MeasureCoreEngine.LightFakeMeasureMode(
            fei,
            WizConstants.FAKE_STYLE,
            WizConstants.MEASURE_MODE_SUBMIT, 
            formula); // construction d'une fausse mesure, pour calcul

        // if(wl.subTotalLevel === 2) {
        //   console.log('computeConsoRowStyle', wl, witness);
        // }

        const cr: ComputeResult = FormulaCoreEngine.computeMmiDependencies(mm.mmi, witness, fei, true);
        
        
        
        if (cr.valor === '1') {
            result = sl.cssAsObject;
            break;
        }
    }
    return result;
  }  

  /**
   * transformation des params pmdEx en objet
   * @param wco 
   */
  public pmdExParams(wco: WidgetConfigurationObj | WidgetConfigurationItemObj): any {
    if(!!wco.pmdexParams) {
      return JSON.parse(wco.pmdexParams);
    }
  }

  /* ##############################################################################
         taille des filtres selon leur type
     ############################################################################## */

  public static BASIC_FILTER_SIZE: number = 160;
  public static ME_FILTER_SIZE: number = 40;
  public static FREE_FILTER_SIZE: number = 100;
  public static ICONS_FILTER_SIZE: number = 50;

  public static getFilterSize(f: IWidgetFilter): number {
    if(f.wcio.csiz) {
      return f.wcio.csiz;
    }
    
    if (f.wcio.cod === ViewData.FILTER_GENERIC) { 
      return this.FREE_FILTER_SIZE;
    } 
    
    if(
      f.wcio.cod === ViewData.FILTER_ME) {  
      return this.ME_FILTER_SIZE;
    }

    // gestion des champs booléen ou formule + format = BOOLEAN = 1
    if(f.onBoolean) {
      // console.log('getFilterSize on boolean', f);
      return this.ME_FILTER_SIZE;
    }

    return this.BASIC_FILTER_SIZE;
  }

}
